/* default-updated-product-v2.js — collection PDP (size + colour only) */
(function(){
  var CFG = window.DUPV2_CONFIG || {};
  function loadInfoTipsFromDom(){
    try {
      var el = document.getElementById('dupv2-info-tips');
      if (!el || !el.textContent) return [];
      var tips = JSON.parse(el.textContent);
      return Object.prototype.toString.call(tips) === '[object Array]' ? tips : [];
    } catch (e) { return []; }
  }
  if (!CFG.infoTips || !CFG.infoTips.length) {
    CFG.infoTips = loadInfoTipsFromDom();
    if (window.DUPV2_CONFIG) window.DUPV2_CONFIG.infoTips = CFG.infoTips;
  }
  var PRODUCT = CFG.product || { options: [], variants: [] };
  var SHOW_VAT = !!CFG.showVat;
  var VAT_RATE = SHOW_VAT ? (parseFloat(CFG.vatRate) || 1) : 1;
  if (!SHOW_VAT || !(VAT_RATE > 1)) VAT_RATE = 1;
  var DISC_PCT = Math.max(0, parseFloat(CFG.discountPercent || 0) || 0) / 100;
  var HAS_GLOBAL = !!CFG.hasGlobalDiscount && DISC_PCT > 0;
  var incl = false, discount = HAS_GLOBAL;
  var currentVariant = PRODUCT.variants && PRODUCT.variants[0] ? PRODUCT.variants[0] : null;
  window.DUPV2_CURRENT_VARIANT = currentVariant;

  function tpl(s, map){
    s = (s == null ? '' : String(s));
    Object.keys(map || {}).forEach(function(k){ s = s.split('{'+k+'}').join(String(map[k])); });
    return s;
  }
  // Indoor / Outdoor — USA UK IT FR NL DK DE SE ES
  function isOutdoorVal(val){
    return /outdoor|exterior|esterno|buiten|extérieur|exterieur|utomhus|udenfor|udendørs|udendoers|aussen|außen|draussen|draußen|all'?aperto|extérieur/i.test(String(val || ''));
  }
  function isIndoorVal(val){
    return /indoor|interior|interno|binnen|intérieur|interieur|inomhus|indenfor|indendørs|indendoers|innenraum|innenbereich|\binnen\b|interno|à.?l'?intérieur/i.test(String(val || ''));
  }
  /**
   * RGB / colour-changing (+25%) — all 9 stores:
   * USA/UK, IT, FR, NL, DK, DE, SE, ES
   */
  function isRgbColorLabel(label){
    var t = String(label || '').toLowerCase().trim();
    if (!t) return false;
    if (/rgb/.test(t)) return true;
    // USA / UK
    if (/colou?r[\s\-]*chang/.test(t)) return true;
    if (/chang(?:ing|eable)[\s\-]*colou?r/.test(t)) return true;
    // NL: Kleurwisselend / Kleur veranderend / Veranderbare kleur
    if (/kleur[\s\-]*wissel/.test(t)) return true;
    if (/kleur[\s\-]*verander/.test(t)) return true;
    if (/verander(?:bare|ende)?\s*kleur/.test(t)) return true;
    // DE: Farbwechsel / Farbwechselnd / Lichtfarben wechseln
    if (/farb[\s\-]*wechsel/.test(t)) return true;
    if (/wechselnd/.test(t) && /farb/.test(t)) return true;
    if (/licht[\s\-]*farben?\s*wechsel/.test(t)) return true;
    // SE / DK
    if (/f[aäæ]r(?:g|ve)[\s\-]*skift/.test(t)) return true;
    if (/f[aäæ]rg[\s\-]*omv[aä]xl/.test(t)) return true;
    // FR: Couleur changeante / Changeante / Multicolore (+25%)
    if (/couleur[\s\-]*chang/.test(t)) return true;
    if (/chang(?:eante|eant)/.test(t) && /couleur|color/.test(t)) return true;
    if (/^changeante\b/.test(t)) return true;
    if (/multicolore/.test(t) && /\+?\s*25\s*%/.test(t)) return true;
    // IT: Cambia colore / Cambiacolore / Colore variabile
    if (/cambi[oa]\s*colou?re?|cambiacolore|colore\s*variabile/.test(t)) return true;
    // ES: Cambio de color / Cambiacolor / Color cambiante
    if (/cambio\s*de\s*colou?r|cambiacolor|colou?r\s*cambiante/.test(t)) return true;
    // PT: Mudança de cor / Cor mutável / Multicor / Cor variável
    if (/mudan[cç]a\s*de\s*cor|cor\s*mud[aá]vel|multicor|cor\s*vari[aá]vel/.test(t)) return true;
    // Generic: surcharge + colour-change wording
    if (/\+?\s*25\s*%/.test(t) && /(chang|wissel|wechsel|skift|verander|colour|color|kleur|couleur|colore|farb|f[aäæ]rg|farve|multicolor|multicor|variable|mudan)/.test(t)) return true;
    return false;
  }
  // Colour map MUST be defined before findThumbForColor / first recalc() (var is not initialized by hoist)
  // USA UK IT FR NL DK DE SE ES — accents folded via foldColorToken
  var COLOR_HEX = {
    white:'#ffffff', wit:'#ffffff', weiss:'#ffffff', weis:'#ffffff', vit:'#ffffff', hvid:'#ffffff',
    bianco:'#ffffff', blanco:'#ffffff', blanc:'#ffffff', branco:'#ffffff',
    warmwhite:'#fff4d6', warmwit:'#fff4d6', warmweiss:'#fff4d6', warmweis:'#fff4d6',
    varmvit:'#fff4d6', vitvarm:'#fff4d6', varmhvid:'#fff4d6', hvidvarm:'#fff4d6',
    biancocaldo:'#fff4d6', blancocalido:'#fff4d6', blancocaliente:'#fff4d6',
    blancchaud:'#fff4d6', blancochaud:'#fff4d6', brancquente:'#fff4d6', brancaquente:'#fff4d6',
    coldwhite:'#f0f7ff', coolwhite:'#f0f7ff', koudwit:'#f0f7ff', kaltweiss:'#f0f7ff',
    biancofreddo:'#f0f7ff', blancofrio:'#f0f7ff', blancfroid:'#f0f7ff', brancofrio:'#f0f7ff',
    yellow:'#ffd23b', geel:'#ffd23b', gelb:'#ffd23b', gul:'#ffd23b', giallo:'#ffd23b',
    amarillo:'#ffd23b', jaune:'#ffd23b', amarelo:'#ffd23b', gold:'#ffc107',
    orange:'#ff8a3d', oranje:'#ff8a3d', arancio:'#ff8a3d', arancione:'#ff8a3d', naranja:'#ff8a3d', laranja:'#ff8a3d',
    red:'#ff3b3b', rood:'#ff3b3b', rot:'#ff3b3b', rod:'#ff3b3b', rosso:'#ff3b3b',
    rojo:'#ff3b3b', rouge:'#ff3b3b', vermelho:'#ff3b3b',
    pink:'#ff4db8', roze:'#ff4db8', rosa:'#ff4db8', rose:'#ff4db8',
    lightpink:'#ffb3d9', lichtroze:'#ffb3d9', hellrosa:'#ffb3d9', ljusrosa:'#ffb3d9',
    lyserod:'#ffb3d9', lyserosa:'#ffb3d9', rosachiaro:'#ffb3d9', rosclaro:'#ffb3d9',
    rosadclaro:'#ffb3d9', lightrose:'#ffb3d9', roseclair:'#ffb3d9', roseclaire:'#ffb3d9',
    rosaclaro:'#ffb3d9', magenta:'#ff3bd2',
    purple:'#8b5cff', violet:'#8b5cff', paars:'#8b5cff', lila:'#8b5cff',
    viola:'#8b5cff', violetta:'#8b5cff', morado:'#8b5cff', purpura:'#8b5cff',
    purper:'#8b5cff', pourpre:'#8b5cff', roxo:'#8b5cff', lilas:'#8b5cff',
    blue:'#3b8cff', blauw:'#3b8cff', blau:'#3b8cff', bla:'#3b8cff', blu:'#3b8cff',
    azul:'#3b8cff', bleu:'#3b8cff',
    lightblue:'#3bd2ff', lichtblauw:'#3bd2ff', hellblau:'#3bd2ff', ljusbla:'#3bd2ff',
    azulclaro:'#3bd2ff', bleuclair:'#3bd2ff', cyan:'#3bd2ff',
    iceblue:'#a8e6ff', ijsblauw:'#a8e6ff', eisblau:'#a8e6ff', isbla:'#a8e6ff',
    isblaa:'#a8e6ff', blughiaccio:'#a8e6ff', bluchiaccio:'#a8e6ff',
    azulhielo:'#a8e6ff', bleuglace:'#a8e6ff', bleuglacier:'#a8e6ff', azulgelo:'#a8e6ff',
    turquoise:'#2ee0c5', turkoois:'#2ee0c5', turkis:'#2ee0c5', turkos:'#2ee0c5',
    turchese:'#2ee0c5', turquesa:'#2ee0c5',
    green:'#39d97a', groen:'#39d97a', grun:'#39d97a', gron:'#39d97a',
    verde:'#39d97a', vert:'#39d97a', lime:'#b8ff3b'
  };
  function foldColorToken(token){
    var t = String(token || '').toLowerCase();
    try { t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return t
      .replace(/ø/g, 'o')
      .replace(/æ/g, 'ae')
      .replace(/ß/g, 'ss')
      .replace(/ð/g, 'd')
      .replace(/[^a-z0-9]+/g, '');
  }
  function colorTokenHex(token){
    if (!COLOR_HEX) return null;
    var t = foldColorToken(token);
    if (!t) return null;
    if (COLOR_HEX[t]) return COLOR_HEX[t];
    var raw = String(token || '').toLowerCase();
    if (/(white|wit|weiss|weis|vit|hvid|bianco|blanco|blanc)/.test(raw)) {
      if (/(warm|varm|caldo|calido|caliente|chaud)/.test(raw)) return COLOR_HEX.warmwhite;
      if (/(cold|cool|koud|kalt|freddo|frio|froid)/.test(raw)) return COLOR_HEX.coldwhite;
    }
    if (/(light\s*pink|licht\s*roze|hell\s*rosa|ljus\s*rosa|lyse\s*r[øo]d|lyse\s*rosa|rosa\s*chiaro|rosa\s*claro|rose\s*clair)/.test(raw)) return COLOR_HEX.lightpink;
    if (/(ice|ijs|eis|isbl|ghiaccio|hielo|glacier|glace)/.test(raw) && /(blue|blauw|blau|bla|blu|azul|bleu)/.test(raw)) return COLOR_HEX.iceblue;
    if (/(light\s*blue|licht\s*blauw|hell\s*blau|ljus\s*bl[aå]|azul\s*claro|bleu\s*clair)/.test(raw)) return COLOR_HEX.lightblue;
    return null;
  }
  /** Split "White+Yellow", "Rouge / Bleu", "Wit en Geel" into colour name parts */
  function splitColorParts(label){
    return String(label || '')
      .replace(/\(\s*\+?\d+\s*%\s*\)/g, '')
      .split(/\+|\/|&|,|\ben\b|\band\b|\bet\b|\be\b|\bund\b|\by\b|\bou\b|\bof\b/i)
      .map(function(s){ return s.trim(); })
      .filter(function(s){ return s && !isRgbColorLabel(s); });
  }
  /** Hex list for a label. RGB → ['__rgb__']. Multi → [hex, hex, …] */
  function colorLabelHexes(label){
    if (isRgbColorLabel(label)) return ['__rgb__'];
    var parts = splitColorParts(label);
    if (!parts.length) {
      var one = colorTokenHex(label) || (COL_HEX && COL_HEX[label]) || null;
      return one ? [one] : [];
    }
    var hexes = [];
    for (var i = 0; i < parts.length; i++) {
      var h = colorTokenHex(parts[i]) || (COL_HEX && COL_HEX[parts[i]]) || null;
      if (h) hexes.push(h);
    }
    return hexes;
  }
  /** Swatch HTML — RGB rainbow / multi overlapping dots / single circle */
  function colorSwatchHtml(label, mode){
    mode = mode || 'dot'; // dot = cval row, tile = picker/modal
    var hexes = colorLabelHexes(label);
    if (hexes[0] === '__rgb__') {
      return mode === 'tile'
        ? '<span class="pk-photo pk-swatch sw-rgb" aria-hidden="true"></span>'
        : '<span class="sw sw-rgb" aria-hidden="true"></span>';
    }
    if (!hexes.length) {
      return mode === 'tile'
        ? '<span class="pk-photo pk-swatch" style="background:#e8e4f0" aria-hidden="true"></span>'
        : '<span class="sw" style="background:#e8e4f0" aria-hidden="true"></span>';
    }
    if (hexes.length === 1) {
      return mode === 'tile'
        ? '<span class="pk-photo pk-swatch" style="background:'+hexes[0]+'" aria-hidden="true"></span>'
        : '<span class="sw" style="background:'+hexes[0]+';box-shadow:0 0 6px '+hexes[0]+'99" aria-hidden="true"></span>';
    }
    var shown = hexes.slice(0, 5);
    if (mode === 'tile') {
      // Striped fallback for picker thumbnail
      var stops = shown.map(function(h, i){
        var a = (i / shown.length * 100).toFixed(1);
        var b = ((i + 1) / shown.length * 100).toFixed(1);
        return h+' '+a+'%, '+h+' '+b+'%';
      }).join(', ');
      return '<span class="pk-photo pk-swatch" style="background:linear-gradient(135deg,'+stops+')" aria-hidden="true"></span>';
    }
    var step = shown.length <= 2 ? 9 : (shown.length === 3 ? 7 : 6);
    var w = 14 + step * (shown.length - 1);
    var html = '<span class="swn" style="width:'+w+'px" aria-hidden="true">';
    for (var j = 0; j < shown.length; j++) {
      var glow = j === 0 ? ';box-shadow:0 0 6px '+shown[j]+'99' : '';
      html += '<i style="left:'+(j*step)+'px;background:'+shown[j]+glow+';z-index:'+(j+1)+'"></i>';
    }
    return html + '</span>';
  }
  function colorCanonKey(token){
    var hex = colorTokenHex(token);
    if (!hex) return foldColorToken(token);
    var map = {
      '#ffffff':'white', '#fff4d6':'warmwhite', '#f0f7ff':'coldwhite',
      '#ffd23b':'yellow', '#ffc107':'gold', '#ff8a3d':'orange', '#ff3b3b':'red',
      '#ff4db8':'pink', '#ffb3d9':'lightpink', '#ff3bd2':'magenta',
      '#8b5cff':'purple', '#3b8cff':'blue', '#3bd2ff':'lightblue',
      '#a8e6ff':'iceblue', '#2ee0c5':'turquoise', '#39d97a':'green', '#b8ff3b':'lime'
    };
    return map[hex] || foldColorToken(token);
  }

  function optNameIs(name, keys){
    var n = String(name || '').toLowerCase();
    return keys.some(function(k){ return n.indexOf(k) !== -1; });
  }
  function findOption(keys){
    var opts = PRODUCT.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (optNameIs(opts[i].name, keys)) return opts[i];
    }
    return null;
  }
  var OPT_SIZE = findOption(['size', 'afmeting', 'dimension', 'maat', 'misura', 'taglia', 'formato', 'tamaño', 'tamano', 'tamanho', 'talla', 'medida', 'größe', 'grosse', 'groesse', 'taille', 'storlek', 'størrelse', 'storrelse', 'dimensioni', 'dimensao', 'dimensão']);
  var OPT_COLOR = findOption(['color', 'colour', 'kleur', 'colore', 'couleur', 'färg', 'farg', 'farbe', 'farve', 'farver', 'colores', 'kleuren', 'farben', 'cor', 'cores']);
  function looksLikeSizeOption(opt){
    var vals = (opt && opt.values) || []; var hit = 0;
    for (var i = 0; i < vals.length; i++) {
      if (/[\d.,]+\s*(cm|mm|in|")?\s*[x×*]\s*[\d.,]+/i.test(String(vals[i] || ''))) hit++;
    }
    return hit >= Math.max(1, Math.ceil(vals.length * 0.4));
  }
  function looksLikeColorOption(opt){
    var vals = (opt && opt.values) || []; if (!vals.length) return false; var hit = 0;
    for (var i = 0; i < vals.length; i++) {
      var v = String(vals[i] || '');
      if (isRgbColorLabel(v) || colorTokenHex(v) || colorLabelHexes(v).length || /\+?\s*25\s*%/i.test(v) || /[+\/%]/.test(v)) hit++;
    }
    return hit >= Math.max(1, Math.ceil(vals.length * 0.35));
  }
  if (!OPT_SIZE || !OPT_COLOR) {
    (PRODUCT.options || []).forEach(function(opt){
      if (!opt) return;
      if (!OPT_SIZE && looksLikeSizeOption(opt) && opt !== OPT_COLOR) OPT_SIZE = opt;
      else if (!OPT_COLOR && looksLikeColorOption(opt) && opt !== OPT_SIZE) OPT_COLOR = opt;
    });
  }
  (PRODUCT.options || []).forEach(function(opt){
    if (!opt) return;
    if (!OPT_SIZE && opt !== OPT_COLOR) OPT_SIZE = opt;
    else if (!OPT_COLOR && opt !== OPT_SIZE) OPT_COLOR = opt;
  });
  if (OPT_SIZE && OPT_COLOR && looksLikeColorOption(OPT_SIZE) && looksLikeSizeOption(OPT_COLOR)) {
    var _swap = OPT_SIZE; OPT_SIZE = OPT_COLOR; OPT_COLOR = _swap;
  }
  if (OPT_SIZE) CFG.sizeOptionName = OPT_SIZE.name;
  if (OPT_COLOR) CFG.colourOptionName = OPT_COLOR.name;

  function parseDims(label){
    var m = String(label || '').match(/([\d.]+)\s*(cm|mm|in|")?\s*[x×*]\s*([\d.]+)/i);
    if (!m) return { w: 100, h: 50, label: label };
    var w = parseFloat(m[1]), h = parseFloat(m[3]);
    var unit = (m[2] || '').toLowerCase();
    if (unit === 'in' || unit === '"') { w = Math.round(w * 2.54); h = Math.round(h * 2.54); }
    return { w: w, h: h, label: label };
  }
  function isDefaultTitle(val){
    return String(val || '').trim().toLowerCase() === 'default title';
  }
  function sizeDisplayLabel(val){
    if (isDefaultTitle(val)) return '';
    return String(val || '');
  }
  function fillSelect(sel, values, mapFn){
    if (!sel) return;
    sel.innerHTML = '';
    (values || []).forEach(function(val, idx){
      if (sel.id === 'selSize' && isDefaultTitle(val)) return;
      var o = document.createElement('option');
      o.value = val; o.textContent = sizeDisplayLabel(val) || val;
      if (mapFn) mapFn(o, val, idx);
      sel.appendChild(o);
    });
  }
  function fmtSekKr(amount){
    var whole = Math.round(Math.abs(Number(amount) || 0));
    return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }
  function fmtMoney(cents){
    var n = (Number(cents) || 0) / 100;
    var code = String(CFG.currencyCode || 'EUR').toUpperCase();
    // Match custom_neon: EUR uses comma decimals; GBP/SEK/DKK get native symbols
    if (code === 'USD') return '$' + n.toFixed(2);
    var grp = function(s, sep){ return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }; // 1.036,71 / 1,030.86 like Liquid's money filter (1 Nov 2026)
    if (code === 'EUR') { var pe = n.toFixed(2).split('.'); return '€' + grp(pe[0], '.') + ',' + pe[1]; }
    if (code === 'GBP') { var pg = n.toFixed(2).split('.'); return '£' + grp(pg[0], ',') + '.' + pg[1]; }
    if (code === 'SEK') return fmtSekKr(n);
    if (code === 'DKK' || code === 'NOK') {
      return n.toFixed(2).replace('.', ',') + ' kr';
    }
    try {
      return n.toLocaleString(undefined, { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' })
        .replace(/^US\s?/i, '')
        .replace(/\s?US$/i, '');
    } catch (e) {
      return code + ' ' + n.toFixed(2);
    }
  }
  function fmt(n){ return fmtMoney(Math.round(Number(n) * 100)); }
  function moneyDelta(absAmount){
    // Whole-currency deltas in pickers (no decimals), still use correct symbol
    var code = String(CFG.currencyCode || 'EUR').toUpperCase();
    var n = Math.round(Math.abs(Number(absAmount) || 0));
    if (code === 'USD') return '$' + n;
    if (code === 'EUR') return '€' + n;
    if (code === 'GBP') return '£' + n;
    if (code === 'SEK') return fmtSekKr(n);
    if (code === 'DKK' || code === 'NOK') return n + ' kr';
    return fmt(n);
  }
  function variantPriceCents(v){ return v ? (v.price || 0) : 0; }
  function compareCents(v){ return v && v.compare_at_price ? v.compare_at_price : 0; }

  // Fallback hex map for English mock names (multi-lang uses colorTokenHex)
  var COL_HEX={"Red": "#ff2a2a", "White": "#ffffff", "Orange": "#ff7a1a", "Green": "#2ee66b", "Ice Blue": "#8ff4ff", "Yellow": "#fff23a", "Light Pink": "#ff9fc0", "Pink": "#ff3fae", "Blue": "#3a6bff", "Purple": "#a66bff", "Turquoise": "#20e3c8", "Warm White": "#ffe7a8"};



  var UV_PRINT = false, UV_AVAILABLE = false;   // collection items have no UV print
  // Prices come from the variants (excl. VAT). Same price for every colour, so only the size changes the price.
  var BASE=194.21, RGB_MULT=1, DISC_PCT=0.25;
  var SIZES=[[50,45.4,194.21],[75,68.2,400.83],[100,91,714.88],[125,113.6,1074.38]];   // live: from variant names "50cm x 45.4 cm" + variant.price
  var COL_HEX={"Red": "#ff2a2a", "White": "#ffffff", "Orange": "#ff7a1a", "Green": "#2ee66b", "Ice Blue": "#8ff4ff", "Yellow": "#fff23a", "Light Pink": "#ff9fc0", "Pink": "#ff3fae", "Blue": "#3a6bff", "Purple": "#a66bff", "Turquoise": "#20e3c8", "Warm White": "#ffe7a8"};
  var incl=false, rgb=false, modelMult=1, discount=true;
  function sizeAdd(){ var s=document.getElementById('selSize'); return s&&s.selectedOptions[0]?parseFloat(s.selectedOptions[0].dataset.add||0):0; }

  // Prijs zoals getoond (korting + btw-schakelaar) voor een bepaalde maattoeslag
  function unitFor(add){ var u=BASE+add; if(rgb) u*=RGB_MULT; return u*modelMult; }
  function shownFor(add){ var u=unitFor(add); if(discount) u*=(1-DISC_PCT); return u*(incl?1.21:1); }


  var START_OTHER = {};
  function findVariant(){
    var variants = PRODUCT.variants || [];
    var sizeVal = selSize && selSize.value;
    var colorVal = selColor && selColor.value;
    for (var i=0;i<variants.length;i++){
      var v=variants[i], ok=true;
      if (OPT_SIZE && String(v['option'+OPT_SIZE.position]) !== String(sizeVal)) ok=false;
      if (OPT_COLOR && String(v['option'+OPT_COLOR.position]) !== String(colorVal)) ok=false;
      for (var p in START_OTHER) if (String(v['option'+p]) !== String(START_OTHER[p])) ok=false; // e.g. a third option like Nutzung (1 Nov 2026)
      if (ok) return v;
    }
    return variants[0] || null;
  }
  function recalc(){
    if(window.updDeltas) setTimeout(updDeltas,0);
    currentVariant = findVariant();
    window.DUPV2_CURRENT_VARIANT = currentVariant;
    var root = document.querySelector('.dupv2');
    if (root && currentVariant) root.setAttribute('data-variant-id', String(currentVariant.id));
    var cents = variantPriceCents(currentVariant);
    var normal = cents / 100;
    // Discounted price rounded to whole cents, the same way as the Liquid start price (31 Oct 2026)
    var finalv = (discount && DISC_PCT > 0) ? Math.round(cents * (100 - Math.round(DISC_PCT * 100)) / 100) / 100 : normal;
    var f = (SHOW_VAT && incl) ? VAT_RATE : 1;
    var priceStr = fmt(finalv * f);
    var vatNote=document.getElementById('vatNoteTop');
    var vatIncl = (CFG.vatInclLabel || (vatNote && vatNote.getAttribute('data-vat-incl')) || '').trim();
    var vatExcl = (CFG.vatExclLabel || (vatNote && vatNote.getAttribute('data-vat-excl')) || '').trim();
    var vatStr = incl ? vatIncl : vatExcl;
    var pt=document.getElementById('priceTop');
    if(pt){
      if(pt.textContent!==priceStr && window.__ready){ pt.classList.remove('bump'); void pt.offsetWidth; pt.classList.add('bump'); }
      pt.textContent=priceStr;
    }
    if(vatNote){
      vatNote.style.display = SHOW_VAT ? '' : 'none';
      if(SHOW_VAT && vatStr) vatNote.textContent = vatStr;
    }
    var stickyPrice=document.getElementById('stickyPrice'); if(stickyPrice) stickyPrice.textContent=priceStr;
    var stickyUnit=document.getElementById('stickyUnit');
    if(stickyUnit){
      if(SHOW_VAT){ stickyUnit.style.display=''; if(vatStr) stickyUnit.textContent=vatStr; }
      else stickyUnit.style.display='none';
    }
    var svT=document.getElementById('saveTop'), poT=document.getElementById('priceOldTop');
    var cmp = compareCents(currentVariant);
    var priceNowCents = Math.round(finalv * 100);
    if(discount && DISC_PCT > 0){
      var oldC=Math.round(normal*f*100), nowC=Math.round(finalv*f*100); // save = shown old price minus shown price (1 Nov 2026)
      var oldStr=fmtMoney(oldC), saveStr=(CFG.savePrefix||'Save')+' '+fmtMoney(oldC-nowC)+' ('+Math.round(DISC_PCT*100)+'%)';
      if(poT){ poT.style.display='inline'; poT.textContent=oldStr; }
      if(svT){ svT.style.display='inline-flex'; svT.textContent=saveStr; }
    } else if (cmp > priceNowCents) {
      var saveCents = cmp - priceNowCents;
      var savePct = Math.round((saveCents / cmp) * 100);
      if(poT){ poT.style.display='inline'; poT.textContent=fmtMoney(Math.round(cmp*f)); }
      if(svT){ svT.style.display='inline-flex'; svT.textContent=(CFG.savePrefix||'Save')+' '+fmtMoney(Math.round(saveCents*f))+(savePct>0?' ('+savePct+'%)':''); }
    } else {
      if(poT) poT.style.display='none';
      if(svT) svT.style.display='none';
    }
    if (selSize && selSize.selectedOptions[0]) {
      var ov = document.getElementById('ovSize');
      var ovBtn = document.getElementById('ovSizeBtn');
      var sizeLab = sizeDisplayLabel(selSize.selectedOptions[0].dataset.size || selSize.selectedOptions[0].textContent);
      if (ov) ov.textContent = sizeLab;
      if (ovBtn) ovBtn.style.display = sizeLab ? '' : 'none';
    }
    try { showVariantImage(currentVariant); } catch (e) {}
  }


  // Size + Colour from Shopify variants (all languages)
  var selSize=document.getElementById('selSize');
  var selColor=document.getElementById('selColor');
  if (OPT_SIZE && selSize) {
    fillSelect(selSize, OPT_SIZE.values, function(o, val){
      var d = parseDims(val);
      var label = sizeDisplayLabel(val);
      o.dataset.size = label;
      o.dataset.w = d.w; o.dataset.h = d.h; o.dataset.add = '0';
      o.textContent = label || val;
    });
    if (selSize.options.length) { var rowSizeShow = selSize.closest('.orow-size') || selSize.closest('.orow'); if (rowSizeShow) rowSizeShow.style.display = ''; }
    if (!selSize.options.length) {
      var rowSize = selSize.closest('.orow-size') || selSize.closest('.orow');
      if (rowSize) rowSize.style.display = 'none';
      var ovBtn = document.getElementById('ovSizeBtn');
      if (ovBtn) ovBtn.style.display = 'none';
    }
  } else if (selSize) {
    var rowSizeHide = selSize.closest('.orow-size') || selSize.closest('.orow');
    if (rowSizeHide) rowSizeHide.style.display = 'none';
    var ovBtnHide = document.getElementById('ovSizeBtn');
    if (ovBtnHide) ovBtnHide.style.display = 'none';
  }
  if (OPT_COLOR && selColor) {
    fillSelect(selColor, OPT_COLOR.values, function(o, val, idx){
      o.dataset.ci = String(idx);
      o.dataset.rgb = isRgbColorLabel(val) ? '1' : '0';
    });
    var rowColorShow = selColor.closest('.orow'); if (rowColorShow && selColor.options.length) rowColorShow.style.display = '';
  }
  else if (selColor) {
    // No colour option on this product: hide the row instead of showing placeholder colours (31 Oct 2026)
    var rowColorHide = selColor.closest('.orow');
    if (rowColorHide) rowColorHide.style.display = 'none';
  }
  if (selSize && selSize.options.length && selSize.selectedIndex < 0) selSize.selectedIndex = 0;
  if (selColor && selColor.options.length && selColor.selectedIndex < 0) selColor.selectedIndex = 0;
  // Start on the variant the server rendered (selected_or_first_available_variant, honours ?variant=), so photo, price and tracking agree (31 Oct 2026)
  (function(){
    var root = document.querySelector('.dupv2');
    var vid = root && root.getAttribute('data-variant-id');
    var v = (PRODUCT.variants || []).filter(function(x){ return String(x.id) === String(vid); })[0];
    if (!v) return;
    function pick(sel, opt){
      if (!sel || !opt) return;
      var val = String(v['option' + opt.position]);
      for (var j = 0; j < sel.options.length; j++) if (sel.options[j].value === val) { sel.selectedIndex = j; return; }
    }
    pick(selSize, OPT_SIZE); pick(selColor, OPT_COLOR);
    (PRODUCT.options || []).forEach(function(o){ var pos = o.position; if ((OPT_SIZE && pos === OPT_SIZE.position) || (OPT_COLOR && pos === OPT_COLOR.position)) return; START_OTHER[pos] = v['option' + pos]; });
  })();
  // Paint oval labels ASAP (full syncVals runs later once defined)
  document.querySelectorAll('.oval[data-for]').forEach(function(el){
    var s=document.getElementById(el.dataset.for); if(!s||!s.options.length) return;
    var o=s.options[s.selectedIndex>=0?s.selectedIndex:0]; if(!o) return;
    var lab = el.dataset.for === 'selSize'
      ? sizeDisplayLabel(o.dataset.size || o.textContent)
      : (o.dataset.size || o.textContent);
    el.textContent = lab;
  });
  // Map each colour option → a Shopify variant image (same colour, any size)
  function variantImageForColor(colorVal){
    var variants = PRODUCT.variants || [];
    var pos = OPT_COLOR ? OPT_COLOR.position : 0;
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v) continue;
      if (pos && String(v['option'+pos]) !== String(colorVal)) continue;
      if (!first) first = v;
      if (v.image) return v;
    }
    return first;
  }
  if (selColor) {
    Array.prototype.forEach.call(selColor.options, function(o, idx){
      o.dataset.ci = String(idx);
      var v = variantImageForColor(o.value || o.textContent);
      if (v && v.image) {
        o.dataset.image = v.image;
        if (v.mediaId) o.dataset.mediaId = String(v.mediaId);
      }
    });
  }

  // Build thumbs from product media when present; tag colour when media matches a variant colour image
  (function(){
    var row=document.getElementById('thumbs'); if(!row) return;
    var media = (CFG.media||[]);
    var scale = row.querySelector('.thumb-scale');
    var colorByMedia = {};
    if (selColor) {
      Array.prototype.forEach.call(selColor.options, function(o){
        if (o.dataset.mediaId) colorByMedia[String(o.dataset.mediaId)] = o.value || o.textContent;
      });
    }
    // Thumbs rendered by the server (1 Nov 2026) are kept, so their small lazy images and the active state stay; only the colour tag is added
    var serverThumbs = {};
    Array.prototype.forEach.call(row.querySelectorAll('.thumb[data-type="img"][data-media-id]'), function(t){ serverThumbs[t.dataset.mediaId] = t; });
    var keepServer = Object.keys(serverThumbs).length > 0;
    if (media.length) {
      if (!keepServer) Array.prototype.slice.call(row.querySelectorAll('.thumb:not(.thumb-scale)')).forEach(function(t){ t.remove(); });
      media.forEach(function(m,i){
        if (!m || !m.src) return;
        var existing = keepServer && m.id ? serverThumbs[String(m.id)] : null;
        if (keepServer && !existing) return;
        var d=existing || document.createElement('div');
        if (!existing) { d.className='thumb'; d.dataset.type='img'; d.dataset.full=m.src; }
        d.dataset.alt = m.alt || '';
        if (m.alt) d.title=m.alt;
        if (m.id) d.dataset.mediaId=String(m.id);
        // Bind thumb → colour when this media is a colour-variant image
        if (m.id && colorByMedia[String(m.id)]) d.dataset.color = colorByMedia[String(m.id)];
        else if (selColor) {
          // Fallback: match alt/filename to a colour label
          for (var j=0;j<selColor.options.length;j++){
            var opt=selColor.options[j], label=opt.value||opt.textContent;
            var canon=colorCanonKey(label), fold=foldColorToken(label);
            var hay=((m.alt||'')+' '+(m.src||'')).toLowerCase();
            var hayFold=foldColorToken(hay);
            if ((canon && canon.length>=3 && (hay.indexOf(canon)!==-1 || hayFold.indexOf(canon)!==-1)) ||
                (fold && fold.length>=3 && hayFold.indexOf(fold)!==-1)) {
              d.dataset.color = label; break;
            }
          }
        }
        if (existing) return;
        d.innerHTML='<img src="'+(m.thumb||m.src)+'" alt="'+(m.alt||'').replace(/"/g,'')+'">';
        if (scale) row.insertBefore(d, scale); else row.appendChild(d);
      });
    }
  })();

  var lastShownVariantImage = '';
  var syncingFromThumb = false;
  function normalizeColorKey(s){
    if (isRgbColorLabel(s)) return '';
    return String(s || '').toLowerCase()
      .replace(/\s*\([^)]*\)\s*/g, ' ')
      .replace(/rgb.*/i, '')
      .replace(/colou?r[\s\-]*chang\w*/gi, '')
      .replace(/kleur[\s\-]*wissel\w*/gi, '')
      .replace(/farb[\s\-]*wechsel\w*/gi, '')
      .replace(/f[aäæ]rg[\s\-]*skift\w*/gi, '')
      .replace(/\+25%/g, '')
      .replace(/[^a-z0-9àèéìòùäæå]+/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function selectedColorName(){
    if (!selColor || !selColor.selectedOptions || !selColor.selectedOptions[0]) return '';
    return (selColor.selectedOptions[0].textContent || selColor.value || '').trim();
  }
  function findThumbForColor(colorName){
    var key = normalizeColorKey(colorName);
    var canon = colorCanonKey(colorName);
    var fold = foldColorToken(colorName);
    var thumbs = document.querySelectorAll('#thumbs .thumb[data-type="img"]');
    // 1) exact data-color match
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].dataset.color && String(thumbs[i].dataset.color) === String(colorName)) return thumbs[i];
    }
    // 2) alt / filename / canon match
    for (var j = 0; j < thumbs.length; j++) {
      var full = thumbs[j].dataset.full || '';
      try { full = decodeURIComponent(full); } catch (e) {}
      var raw = (thumbs[j].dataset.alt || thumbs[j].title || '') + ' ' + full;
      var hay = normalizeColorKey(raw);
      var hayFold = foldColorToken(raw);
      if (key && hay && hay.indexOf(key) !== -1) return thumbs[j];
      if (fold && fold.length >= 3 && hayFold.indexOf(fold) !== -1) return thumbs[j];
      if (canon && canon.length >= 3) {
        if (hay.indexOf(canon) !== -1 || hayFold.indexOf(canon) !== -1) return thumbs[j];
        var parts = String(raw || '').toLowerCase().split(/[^a-zà-ÿ0-9]+/i);
        for (var p = 0; p < parts.length; p++) {
          if (parts[p] && colorCanonKey(parts[p]) === canon) return thumbs[j];
        }
      }
    }
    return null;
  }
  function activateThumb(match){
    if (!match) return;
    document.querySelectorAll('#thumbs .thumb').forEach(function(x){ x.classList.remove('active'); });
    match.classList.add('active');
    var row = match.parentNode;
    if (row && row.scrollTo) {
      try { row.scrollTo({left:match.offsetLeft-row.offsetLeft-(row.clientWidth-match.offsetWidth)/2,behavior:'smooth'}); } catch(e){}
    }
  }
  function setStageImage(url){
    if (!url) return;
    var img=document.getElementById('stageImg'), sc=document.getElementById('stageScale'), stage=document.querySelector('.stage');
    var fb=document.getElementById('stageFallback');
    if (stage) stage.classList.remove('is-scale');
    if (sc) sc.style.display='none';
    if (img){
      // Same photo as the server rendered: keep its srcset instead of downloading the 1400px copy (1 Nov 2026)
      var path=function(u){ try { return new URL(u, location.href).pathname; } catch(e){ return String(u||'').split('?')[0]; } };
      if (!(img.getAttribute('srcset') && path(img.getAttribute('src')) === path(url))) { img.removeAttribute('srcset'); img.src=url; }
      img.style.display='block';
    }
    if (fb) fb.style.display='none';
  }
  function showVariantImage(v){
    var opt = selColor && selColor.selectedOptions[0];
    var url = (v && v.image) || (opt && opt.dataset.image) || '';
    var mediaId = (v && v.mediaId) || (opt && opt.dataset.mediaId) || '';
    var colorName = selectedColorName();
    var key = String(mediaId || url || '') + '|' + normalizeColorKey(colorName);
    if (key === lastShownVariantImage) return;
    var stage=document.querySelector('.stage');
    if (stage && stage.classList.contains('is-scale')) {
      lastShownVariantImage = key;
      // Stay in scale mode, but sync colour stroke + active colour thumb
      try {
        var matchScale = findThumbForColor(colorName);
        if (matchScale) activateThumb(matchScale);
      } catch (e) {}
      try {
        var zc = curSize();
        scaleNow = { w: zc.w, h: zc.h };
        drawScaleAt(zc.w, zc.h);
      } catch (e2) {
        try { drawScale(); } catch (e3) {}
      }
      var sbScale=document.querySelector('.sb-th');
      if (sbScale && opt && opt.dataset.image) {
        sbScale.style.backgroundImage='url("'+String(opt.dataset.image).replace('width=1400','width=200')+'")';
      }
      return;
    }

    var match = null;
    // The variant's own image first; matching by colour name picked e.g. "Ice Blue" for "Blauw" (31 Oct 2026)
    if (url) {
      var vbase = String(url).split('?')[0];
      var vthumbs = document.querySelectorAll('#thumbs .thumb[data-type="img"]');
      for (var k=0;k<vthumbs.length;k++){
        var vfull = vthumbs[k].dataset.full || '';
        if (vfull && (vfull===url || vfull.split('?')[0]===vbase)){ match=vthumbs[k]; break; }
      }
    }
    if (!match) { try { match = findThumbForColor(colorName); } catch (e) { match = null; } }
    if (!match && mediaId) {
      var thumbs = document.querySelectorAll('#thumbs .thumb[data-type="img"]');
      for (var i=0;i<thumbs.length;i++){
        if (thumbs[i].dataset.mediaId && String(thumbs[i].dataset.mediaId)===String(mediaId)){ match=thumbs[i]; break; }
      }
    }
    if (!match && url) {
      var base = String(url).split('?')[0];
      var thumbs2 = document.querySelectorAll('#thumbs .thumb[data-type="img"]');
      for (var j=0;j<thumbs2.length;j++){
        var full = thumbs2[j].dataset.full || '';
        if (full && (full===url || full.split('?')[0]===base)){ match=thumbs2[j]; break; }
      }
    }
    lastShownVariantImage = key;
    if (match) {
      activateThumb(match);
      setStageImage(match.dataset.full || url);
    } else if (url) {
      setStageImage(url);
    }
    var sb=document.querySelector('.sb-th');
    if(sb && (match||url)) sb.style.backgroundImage='url("'+String((match&&match.dataset.full)||url).replace('width=1400','width=200')+'")';
    try { syncYxProdImages(match && match.dataset.full ? match.dataset.full : url); } catch (eYx) {}
  }

  function syncYxProdImages(preferUrl){
    var src = preferUrl ? resizeImgUrl(preferUrl, 1000) : '';
    if (!src) {
      var selYx = document.getElementById('selColor');
      if (selYx && selYx.selectedOptions && selYx.selectedOptions[0]) {
        src = colorOptionImage(selYx.selectedOptions[0], 1000);
      }
    }
    if (!src) {
      var stageImg = document.getElementById('stageImg');
      if (stageImg && stageImg.src && stageImg.style.display !== 'none') {
        src = resizeImgUrl(stageImg.src, 1000);
      }
    }
    if (!src) return;
    document.querySelectorAll('[data-yx-prod], #yxProd').forEach(function(yx){
      if (yx && yx.tagName === 'IMG') yx.src = src;
    });
  }

  if(selSize) selSize.addEventListener('change', function(){
    var ov=document.getElementById('ovSize');
    var ovBtn=document.getElementById('ovSizeBtn');
    if(this.selectedOptions[0]){
      var sizeLab=sizeDisplayLabel(this.selectedOptions[0].dataset.size || this.selectedOptions[0].textContent);
      if(ov) ov.textContent=sizeLab;
      if(ovBtn) ovBtn.style.display=sizeLab?'':'none';
    }
    recalc();
  });

  function resizeImgUrl(url, w){
    if (!url) return '';
    var u = String(url);
    if (/([?&])width=\d+/i.test(u)) return u.replace(/([?&])width=\d+/i, '$1width='+w);
    if (u.indexOf('?') === -1) return u + '?width=' + w;
    return u + '&width=' + w;
  }
  function colorOptionImage(opt, w){
    if (!opt) return '';
    w = w || 1400;
    var url = opt.dataset.image || '';
    if (!url) {
      try {
        var th = findThumbForColor(opt.value || opt.textContent || '');
        if (th && th.dataset.full) url = th.dataset.full;
      } catch (e) {}
    }
    if (!url) {
      var v = variantImageForColor(opt.value || opt.textContent || '');
      if (v && v.image) url = v.image;
    }
    return resizeImgUrl(url, w);
  }
  function colorOptionHex(opt){
    var n = opt ? (opt.textContent || opt.value || '') : '';
    var hexes = colorLabelHexes(n);
    if (hexes[0] === '__rgb__') return '#ff2d92'; // scale stroke fallback; swatch uses rainbow
    return hexes[0] || colorTokenHex(n) || COL_HEX[n] || '#ff2d92';
  }

  // Colour: stage + thumbs follow the selected colour's variant image (NOT gallery index)
  function curHex(){ var o=selColor && selColor.selectedOptions ? selColor.selectedOptions[0] : null; return colorOptionHex(o); }
  if(selColor) selColor.addEventListener('change', function(){
    lastShownVariantImage = ''; // force refresh
    recalc();
    var stage=document.querySelector('.stage');
    if (stage && stage.classList.contains('is-scale')) {
      try {
        var zc = curSize();
        scaleNow = { w: zc.w, h: zc.h };
        drawScaleAt(zc.w, zc.h);
      } catch (e) { try { drawScale(); } catch (e2) {} }
    }
  });

  // Achterwand-type → weerspiegeld in "Jij ontvangt"
  var selBoard=document.getElementById('selBoard');
  if(selBoard) selBoard.addEventListener('change', function(){ var ib=document.getElementById('incBoard'); if(ib) ib.textContent=this.value; });

  // UV-print keuze → stuurt UV_PRINT (toont/verbergt de UV-regel in 'Jij ontvangt')
  var selUV=document.getElementById('selUV');
  if(selUV) selUV.addEventListener('change', function(){ UV_PRINT=this.value==='1'; applyUV(); });

  // Video in de info-tooltip: speelt zodra de tooltip open is (hover of tik)
  document.querySelectorAll('.tip-video').forEach(function(t){
    var v=t.querySelector('.tip-vid'); if(!v) return;
    t.addEventListener('mouseenter', function(){ try{ v.play(); }catch(e){} });
    t.addEventListener('mouseleave', function(){ try{ v.pause(); }catch(e){} });
    t.addEventListener('click', function(){
      setTimeout(function(){ if(t.classList.contains('open')){ try{v.play();}catch(e){} } else { try{v.pause();}catch(e){} } }, 0);
    });
  });
  var btwToggle=document.getElementById('btwToggle'); if(btwToggle) btwToggle.addEventListener('click', function(){ incl=!incl; this.classList.toggle('on',incl); recalc(); });

  // UV-print: conditionele info-indicatie. Alleen zichtbaar als UV_PRINT true is, anders nergens.
  // Herberekent de UV-zichtbaarheid overal (roze regel bovenaan + UV-regel in de specs).
  function applyUV(){
    var li=document.getElementById('incUv'); if(li) li.style.display = (UV_AVAILABLE && UV_PRINT) ? '' : 'none';
  }
  function applyUvVis(){
    var row=document.getElementById('rowUV'); if(row) row.style.display = UV_AVAILABLE ? 'flex' : 'none';
    applyUV();
  }

  // Tooltips: hover op desktop, tik om te openen op mobiel
  // Skip .oinfo — those open the info modal, not tip-pop
  document.querySelectorAll('.tip, .term').forEach(function(t){
    if (t.classList.contains('oinfo')) return;
    t.addEventListener('click', function(e){
      e.stopPropagation();
      var was=t.classList.contains('open');
      document.querySelectorAll('.tip.open,.term.open').forEach(function(x){x.classList.remove('open')});
      if(!was) t.classList.add('open');
    });
  });
  document.addEventListener('click', function(){ document.querySelectorAll('.tip.open,.term.open').forEach(function(x){x.classList.remove('open')}); });

  // Aflopende-korting countdown (dd HH:MM:SS)
  // Echte einddatum van de actie. Een timer die bij elk bezoek opnieuw begint is misleidend (ACM).
  // Na de einddatum verdwijnt de timer vanzelf.
  // Same as custom_neon: Theme settings → delivery_days_offset (calendar days, not working days)
  var DELIVERY_MIN = 11, DELIVERY_MAX = 15;
  function parseDeliveryOffset(raw){
    raw = (raw == null ? '' : String(raw)).trim().replace(/[\u2013\u2014]/g, '-');
    var min = 11, max = 15;
    if (!raw) return { min: min, max: max };
    if (raw.indexOf('-') > -1) {
      var p = raw.split('-').map(function(v){ return parseInt(v.trim(), 10); });
      if (!isNaN(p[0])) min = p[0];
      if (!isNaN(p[1])) max = p[1]; else max = min;
    } else {
      var n = parseInt(raw, 10);
      if (!isNaN(n)) { min = n; max = n; }
    }
    return { min: min, max: max };
  }
  function syncDeliveryDays(){
    var el = document.getElementById('eta');
    var raw = CFG.deliveryDaysOffset;
    if (raw == null || String(raw).trim() === '') raw = el && el.getAttribute('data-delivery-days');
    var d = parseDeliveryOffset(raw || '11-15');
    DELIVERY_MIN = d.min; DELIVERY_MAX = d.max;
    return d;
  }
  syncDeliveryDays();
  // Promo bar (live: theme settings)
  //  - Named promo (name + real end date): brand gradient bar with white timer
  //  - Discount without a promo (no name): normal light pink bar, timer only when there is an end date
  // Promo bar — optional HTML (live theme uses sitewide banner; PDP may omit these nodes)
  var PROMOS = {
    back2work:   { name:'BACK2WORK',    pct:0.25, end:'2026-10-31T23:59:59' },
    blackfriday: { name:'Black Friday', pct:0.35, end:'2026-11-30T23:59:59' },
    discount:    { name:'',             pct:0.25, end:'' }
  };
  var PROMO = PROMOS[(location.search.match(/[?&]promo=(back2work|blackfriday|discount)/)||[])[1] || 'back2work'];
  var topbanner=document.getElementById('topbanner');
  var promoNameEl=document.getElementById('promoName');
  var promoPctEl=document.getElementById('promoPct');
  if(PROMO.name && topbanner) topbanner.classList.add('bn-promo');
  else if(promoNameEl) promoNameEl.style.display='none';
  var bgm=location.search.match(/[?&]bg=(yellow2?|pink|black|deep|red|blue|greenlight|green)/);
  if(bgm && PROMO.name && topbanner) topbanner.classList.add('bg-'+bgm[1]);
  var PROMO_NAME = PROMO.name, PROMO_END = PROMO.end || '2000-01-01';
  // Keep theme discount from DUPV2_CONFIG when live; only override for mock ?promo=
  if(location.search.match(/[?&]promo=/)) DISC_PCT = PROMO.pct;
  else if(typeof window.DUPV2_CONFIG !== 'undefined' && window.DUPV2_CONFIG.discountPercent != null) {
    DISC_PCT = Math.max(0, parseFloat(window.DUPV2_CONFIG.discountPercent) || 0) / 100;
  }
  var PROMO_PCT = Math.round(DISC_PCT*100)+'%';
  if(promoNameEl) promoNameEl.textContent = PROMO_NAME;
  if(promoPctEl) promoPctEl.textContent = PROMO_PCT;
  (function(){
    /* Only touch PDP-local #topbanner repeats — sitewide header bar uses Theme Editor banner text */
    var root = document.getElementById('topbanner');
    if (!root) return;
    var one = '<span>' + PROMO_PCT + ' ' + (PROMO_NAME ? PROMO_NAME + ' ' : '') + 'discount</span>', h = '';
    for (var i = 0; i < 12; i++) h += one;
    root.querySelectorAll('.tb-rep').forEach(function (e) { e.innerHTML = h; });
  })();
  (function(){
    var box=document.getElementById('promoTimer'); if(!box) return;
    var end=new Date(PROMO_END).getTime();
    function pad(n){return String(n).padStart(2,'0');}
    var pc=document.getElementById('promoCd');
    function upd(){
      var s=Math.max(0,Math.floor((end-Date.now())/1000));
      if(s===0){ refreshTimer(); return; }
      var d=Math.floor(s/86400); s-=d*86400; var h=Math.floor(s/3600); s-=h*3600; var m=Math.floor(s/60); s-=m*60;
      if(pc) pc.textContent=(d>0?d+'d ':'')+pad(h)+':'+pad(m)+':'+pad(s);
    }
    window.promoActive=function(){ return Date.now()<end; };
    upd(); setInterval(upd,1000);
  })();
  function refreshTimer(){
    var tb=document.getElementById('topbanner'); if(tb) tb.style.display = discount ? 'block' : 'none';
    window.dispatchEvent(new Event('resize'));
    var on=(!window.promoActive || window.promoActive());
    ['promoTimer','promoEnds'].forEach(function(id){ var e=document.getElementById(id); if(e) e.style.display = on ? '' : 'none'; });
    if(tb) tb.classList.toggle('no-timer', !on);
  }
  var kortingToggle=document.getElementById('kortingToggle');
  if(kortingToggle) kortingToggle.addEventListener('click', function(){
    discount=!discount; this.classList.toggle('on',discount);
    refreshTimer(); recalc();
  });
  refreshTimer();

  // Thumbnails — colour sync by data-color / mediaId, never gallery index
  document.querySelectorAll('#thumbs .thumb').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('#thumbs .thumb').forEach(function(x){x.classList.remove('active')});
      t.classList.add('active');
      var img=document.getElementById('stageImg'), sc=document.getElementById('stageScale'), stage=document.querySelector('.stage');
      if(!stage) return;
      stage.classList.toggle('is-scale', t.dataset.type==='scale'); if(sc) sc.style.display='none';
      if(t.dataset.type==='scale'){ if(img) img.style.display='none'; if(sc) sc.style.display='block'; drawScale(); }
      else {
        if(img){ img.removeAttribute('srcset'); img.src=t.dataset.full; img.style.display='block'; }
        var fb=document.getElementById('stageFallback'); if(fb) fb.style.display='none';
        var s=document.getElementById('selColor');
        if (s && t.dataset.color) {
          var want = String(t.dataset.color);
          var idx = -1;
          for (var i=0;i<s.options.length;i++){
            if (String(s.options[i].value)===want || String(s.options[i].textContent)===want){ idx=i; break; }
          }
          if (idx >= 0 && s.selectedIndex !== idx) {
            syncingFromThumb = true;
            s.selectedIndex = idx;
            s.dispatchEvent(new Event('change',{bubbles:true}));
            syncingFromThumb = false;
          }
        }
        lastShownVariantImage = '';
      }
      if (typeof updOvSize === 'function') updOvSize();
    });
  });

  document.querySelectorAll('.dupv2 .faq-q, [data-dupv2-faq] .faq-q').forEach(function(q){
    if (q.dataset.boundFaq) return;
    q.dataset.boundFaq = '1';
    q.addEventListener('click', function(){ q.parentElement.classList.toggle('open'); });
  });
  var atcMain=document.getElementById('atcMain'); if(atcMain) atcMain.addEventListener('click', function(){
    var btn=this; if(!currentVariant) return;
    var fd=new FormData(); fd.append('id', currentVariant.id); fd.append('quantity', 1);
    document.querySelectorAll('#optlist select[data-prop]').forEach(function(s){ var o=s.selectedOptions[0]; if(o && s.dataset.prop) fd.append('properties['+s.dataset.prop+']', o.textContent.trim()); });
    btn.disabled=true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy','true');
    var stk=document.getElementById('stickyAtc'); if(stk){ stk.classList.add('is-loading'); stk.setAttribute('aria-busy','true'); }
    fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.href = ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart'; })
      .catch(function(){ atcReset(); });
  });
  // Spinner while adding; reset when the page comes back from the back/forward cache (31 Oct 2026)
  function atcReset(){
    ['atcMain','stickyAtc'].forEach(function(id){ var b=document.getElementById(id); if(!b) return; b.disabled=false; b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
  }
  window.addEventListener('pageshow', function(e){ if (e.persisted) atcReset(); });
  (function(){
    var st=document.createElement('style');
    st.textContent='.dupv2 .atc.is-loading{position:relative;color:transparent!important;pointer-events:none}.dupv2 .atc.is-loading svg{visibility:hidden}.dupv2 .atc.is-loading::after{content:"";position:absolute;left:50%;top:50%;width:20px;height:20px;margin:-10px 0 0 -10px;border:2.5px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:dupv2spin .7s linear infinite}@keyframes dupv2spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(st);
  })();
  
  recalc();

  // ===== Maat op schaal =====
  function curSize(){
    var o=document.getElementById('selSize') && document.getElementById('selSize').selectedOptions[0];
    if (!o) return {w:100, h:50, label:''};
    return {w:+(o.dataset.w||100), h:+(o.dataset.h||50), label:sizeDisplayLabel(o.dataset.size || o.textContent)};
  }
  function canStepSize(){
    var s=document.getElementById('selSize');
    return !!(s && s.options.length > 1);
  }
  function syncScaleCtrl(){
    var root=document.querySelector('.dupv2') || document;
    var ctrl=root.querySelector('.sc-ctrl');
    if(!ctrl) return;
    // Hide +/- when empty label, no size option, or only one size (nothing to step)
    var show = canStepSize() && !!curSize().label;
    ctrl.style.display = show ? 'flex' : 'none';
    var zm=document.getElementById('szMinus'), zp=document.getElementById('szPlus');
    if(zm) zm.style.display = show ? '' : 'none';
    if(zp) zp.style.display = show ? '' : 'none';
  }
  function updOvSize(){
    var z=curSize(), sc=document.querySelector('.stage').classList.contains('is-scale');
    var ov=document.getElementById('ovSize'); if(ov) ov.textContent = z.label;
    var ovBtn=document.getElementById('ovSizeBtn'); if(ovBtn) ovBtn.style.display = z.label ? '' : 'none';
    var sv=document.getElementById('scVal'); if(sv) sv.textContent=z.label;
    var l=document.getElementById('scaleLinkSize'); if(l) l.textContent=z.label;
    syncScaleCtrl();
  }
  // Schaalscène in cm: lichte muur, balie, persoon van 1,80 m, bord met maatlijnen
  var scaleNow=null;
  // Outline of this design in a 100 × 91 box (live: a transparent cut-out of the product, e.g. a metafield)
  var SCALE_ART='<circle cx="30" cy="16" r="6"/><path d="M30 26l-12 34h24z M24 60v20 M36 60v20"/><path d="M50 10v72"/><circle cx="70" cy="16" r="6"/><path d="M62 26h16v32h-4v24 M62 26v32h4v24 M70 58v24"/>';
  // The product's own photo cropped to the sign's shape; it is the photo that is already loaded, so no extra download (1 Nov 2026)
  var SCALE_IMG='';
  function scaleArt(x,y,w,h){
    if(!SCALE_IMG){ var si=document.getElementById('stageImg'); if(si && si.currentSrc && si.naturalWidth) SCALE_IMG=si.currentSrc; }
    if(!SCALE_IMG) return '<g transform="translate('+x+' '+y+') scale('+(w/100)+' '+(h/91)+')" fill="none" stroke="'+curHex()+'" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" filter="url(#glow)">'+SCALE_ART+'</g>';
    var r=Math.min(3,h*.06);
    return '<clipPath id="scClip"><rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" rx="'+r+'"/></clipPath>'+
      '<image href="'+SCALE_IMG.replace(/"/g,'&quot;')+'" x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" preserveAspectRatio="xMidYMid slice" clip-path="url(#scClip)"/>';
  }
  function drawScaleAt(w, h){
    var svg=document.getElementById('scaleSvg'); if(!svg) return;
    // Scene in cm. The view zooms out for big signs so nothing falls off; person and sofa shrink along (fair comparison).
    var F=262, SOFA=226;
    var ch=Math.max(165, 95+h/2);                 // hanging height of the sign centre: at least 10 cm above the sofa (85 cm)
    var cx=Math.max(SOFA, 90+w/2);                // never in front of the person
    var cy=F-ch, x=cx-w/2, y=cy-h/2;
    var minX=0, minY=Math.min(0, y-30), W=Math.max(392, x+w+34), H=280-minY;
    if(W/H<1.4){ var nw=H*1.4; minX=-(nw-W)/2; W=nw; } else { var nh=W/1.4; minY=280-nh; H=nh; }   // keep the 392:280 frame, no empty bands
    var k=H/280;                                   // zoom factor: labels and dimension lines grow with it so they stay readable
    svg.setAttribute('viewBox', minX+' '+minY+' '+W+' '+H);
    var lab=function(t,x,y,rot){ return '<text x="'+x+'" y="'+y+'" class="sc-lab" style="font-size:'+(10*k)+'px"'+(rot?' transform="rotate(-90 '+x+' '+y+')"':'')+' text-anchor="middle">'+t+'</text>'; };
    var dim='class="sc-dim" style="stroke-width:'+(.8*k)+'"';
    var g='<defs><linearGradient id="wall" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e4ddd3"/><stop offset="1" stop-color="#d3cabd"/></linearGradient>'+
      '<filter id="glow" x="-40%" y="-80%" width="180%" height="260%"><feGaussianBlur stdDeviation="'+Math.max(.8,h*.03)+'" result="b"/><feFlood flood-color="'+curHex()+'" flood-opacity=".85" result="c"/><feComposite in="c" in2="b" operator="in" result="g"/><feMerge><feMergeNode in="g"/><feMergeNode in="g"/><feMergeNode in="SourceGraphic"/></feMerge></filter>'+
      '<filter id="shade"><feDropShadow dx="0" dy="1.2" stdDeviation="1.4" flood-color="#3a3326" flood-opacity=".28"/></filter></defs>'+
      '<rect x="'+minX+'" y="'+minY+'" width="'+W+'" height="'+(F-minY)+'" fill="url(#wall)"/>'+
      '<rect x="'+minX+'" y="'+F+'" width="'+W+'" height="'+(H+minY-F+1)+'" fill="#bfb19c"/><rect x="'+minX+'" y="'+(F-6)+'" width="'+W+'" height="6" fill="#efe9e0"/>'+
      // sofa (200 cm wide, 85 cm high) + plant
      '<g filter="url(#shade)">'+
        '<rect x="'+(SOFA-96)+'" y="'+(F-85)+'" width="192" height="44" rx="12" fill="#a8927a"/>'+
        '<rect x="'+(SOFA-90)+'" y="'+(F-80)+'" width="88" height="36" rx="10" fill="#b9a38a"/><rect x="'+(SOFA+2)+'" y="'+(F-80)+'" width="88" height="36" rx="10" fill="#b9a38a"/>'+
        '<rect x="'+(SOFA-100)+'" y="'+(F-46)+'" width="200" height="24" rx="9" fill="#c4ae94"/>'+
        '<rect x="'+(SOFA-108)+'" y="'+(F-62)+'" width="20" height="44" rx="9" fill="#ad977e"/><rect x="'+(SOFA+88)+'" y="'+(F-62)+'" width="20" height="44" rx="9" fill="#ad977e"/>'+
        '<rect x="'+(SOFA-96)+'" y="'+(F-22)+'" width="4" height="22" fill="#6d5c4a"/><rect x="'+(SOFA+92)+'" y="'+(F-22)+'" width="4" height="22" fill="#6d5c4a"/>'+
        '<path d="M'+(SOFA+128)+' '+F+'l-3-30h26l-3 30z" fill="#e9e2d7" stroke="#cfc4b4" stroke-width=".8"/>'+
        '<g fill="#7f9a6c"><ellipse cx="'+(SOFA+138)+'" cy="'+(F-48)+'" rx="7" ry="18" transform="rotate(-18 '+(SOFA+138)+' '+(F-48)+')"/><ellipse cx="'+(SOFA+146)+'" cy="'+(F-52)+'" rx="6" ry="20" transform="rotate(14 '+(SOFA+146)+' '+(F-52)+')"/><ellipse cx="'+(SOFA+131)+'" cy="'+(F-40)+'" rx="5" ry="13" transform="rotate(-40 '+(SOFA+131)+' '+(F-40)+')"/></g>'+
      '</g>'+
      // person (180 cm)
      '<path class="sc-person" d="M55 '+(F-180)+'a11 11 0 1 1 0 22a11 11 0 1 1 0-22zM40 '+(F-152)+'q15-6 30 0q6 2 7 9l3 44q0 4-4 4h-3l-2-34v28l-2 101h-11l-3-74l-3 74h-11l-2-101v-28l-2 34h-3q-4 0-4-4l3-44q1-7 7-9z"/>'+
      '<line x1="18" x2="18" y1="'+(F-180)+'" y2="'+F+'" '+dim+'/><line x1="'+(18-4*k)+'" x2="'+(18+4*k)+'" y1="'+(F-180)+'" y2="'+(F-180)+'" '+dim+'/>'+lab('1.80 m',18-7*k,F-90,true)+
      // sign
      '<g filter="url(#shade)"><rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" rx="'+Math.min(3,h*.06)+'" fill="rgba(40,32,24,.10)" stroke="rgba(60,50,40,.18)" stroke-width=".6"/></g>'+
      scaleArt(x,y,w,h)+
      // dimension lines
      '<line x1="'+x+'" x2="'+(x+w)+'" y1="'+(y-8*k)+'" y2="'+(y-8*k)+'" '+dim+'/><line x1="'+x+'" x2="'+x+'" y1="'+(y-11*k)+'" y2="'+(y-5*k)+'" '+dim+'/><line x1="'+(x+w)+'" x2="'+(x+w)+'" y1="'+(y-11*k)+'" y2="'+(y-5*k)+'" '+dim+'/>'+
      lab(Math.round(w)+' cm', cx, y-13*k)+
      '<line x1="'+(x+w+8*k)+'" x2="'+(x+w+8*k)+'" y1="'+y+'" y2="'+(y+h)+'" '+dim+'/><line x1="'+(x+w+5*k)+'" x2="'+(x+w+11*k)+'" y1="'+y+'" y2="'+y+'" '+dim+'/><line x1="'+(x+w+5*k)+'" x2="'+(x+w+11*k)+'" y1="'+(y+h)+'" y2="'+(y+h)+'" '+dim+'/>'+
      lab(Math.round(h)+' cm', x+w+19*k, cy, true);
    svg.innerHTML=g;
  }
  function drawScale(){
    var z=curSize();
    if(!scaleNow || !document.querySelector('.stage').classList.contains('is-scale')){ scaleNow={w:z.w,h:z.h}; drawScaleAt(z.w,z.h); return; }
    var from={w:scaleNow.w,h:scaleNow.h}, t0=performance.now(), dur=260;
    (function step(t){
      var k=Math.min(1,(t-t0)/dur), e=1-Math.pow(1-k,3);
      scaleNow={w:from.w+(z.w-from.w)*e, h:from.h+(z.h-from.h)*e};
      drawScaleAt(scaleNow.w, scaleNow.h);
      if(k<1) requestAnimationFrame(step);
    })(t0);
  }
  document.getElementById('selSize').addEventListener('change', function(){ drawScale(); updOvSize(); });

  // ===== Maatlabel in de foto: tik = maat aanpassen =====
  document.getElementById('ovSizeBtn').addEventListener('click', function(){
    document.getElementById('configurator').scrollIntoView({behavior:'smooth'});
    var row=document.querySelector('.orow-size'); setTimeout(function(){ row.classList.remove('flash'); void row.offsetWidth; row.classList.add('flash'); }, 350);
  });

  // ===== Prijsverschil per maat in de keuzelijst =====
  window.ddOnOpen={ selSize:function(menu, sel){
    var cur=shownFor(parseFloat(sel.selectedOptions[0].dataset.add||0));
    menu.querySelectorAll('li').forEach(function(li){
      var i=+li.dataset.i, d=shownFor(parseFloat(sel.options[i].dataset.add||0))-cur, dx=li.querySelector('.dx');
      dx.textContent = i===sel.selectedIndex ? '' : (d>0?'+':'−')+moneyDelta(d);
      dx.className='dx'+(d<0?' neg':'');
    });
  }};


  // ===== Samenstelling in de link (doorsturen) =====
  // Must not reuse CFG — that wipes currencyCode / product config (falls back to EUR)
  var URL_CFG=[['s','selSize'],['c','selColor']];
  (function(){
    var q=new URLSearchParams(location.search);
    URL_CFG.forEach(function(k){ var v=q.get(k[0]), s=document.getElementById(k[1]); if(v!==null && s && s.options[+v]){ s.selectedIndex=+v; s.dispatchEvent(new Event('change')); } });
  })();
  function cfgUrl(){ var q=URL_CFG.map(function(k){ var s=document.getElementById(k[1]); return k[0]+'='+(s?s.selectedIndex:0); }).join('&'); return location.href.split('?')[0].split('#')[0]+'?'+q; }
  function cfgSummary(){
    var t=function(id){ var s=document.getElementById(id); return s.options[s.selectedIndex].textContent; };
    return [t('selSize'), t('selColor')].join(', ');
  }

  // ===== Offerte =====
  function openQuote(){
    var t=function(id){ var s=document.getElementById(id); return s.options[s.selectedIndex].textContent; };
    var rows=[['Size (w × h)',curSize().label],['Backboard','Cut to Shape'],['Colour',t('selColor')]];
    if(UV_AVAILABLE) rows.splice(3,0,['UV print','Applied']);
    var normal=unitFor(sizeAdd()), sub=discount?normal*(1-DISC_PCT):normal, disc=normal-sub, vat=sub*0.21;
    var h=rows.map(function(r){ return '<tr><td>'+r[0]+'</td><td>'+r[1]+'</td></tr>'; }).join('');
    h+='<tr class="q-sep"><td>Price excl. VAT</td><td>'+fmt(normal)+'</td></tr>';
    if(discount) h+='<tr class="q-disc"><td>Discount '+Math.round(DISC_PCT*100)+'%</td><td>−'+fmt(disc)+'</td></tr>';
    h+='<tr><td>Subtotal excl. VAT</td><td>'+fmt(sub)+'</td></tr><tr><td>VAT 21%</td><td>'+fmt(vat)+'</td></tr><tr class="q-total"><td>Total incl. VAT</td><td>'+fmt(sub+vat)+'</td></tr>';
    document.getElementById('qRows').innerHTML=h;
    document.getElementById('qDate').textContent=new Date().toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'});
    var qW=document.getElementById('qWarr'), oW=document.getElementById('ovWarr');
    if(qW) qW.textContent=oW?oW.textContent:'';
    document.getElementById('quoteModal').classList.add('open');
  }
  function closeQuote(){ document.getElementById('quoteModal').classList.remove('open'); }
  document.querySelectorAll('.js-quote').forEach(function(b){ b.addEventListener('click', openQuote); });
  var quoteClose=document.getElementById('quoteClose'); if(quoteClose) quoteClose.addEventListener('click', closeQuote);
  var quoteModal=document.getElementById('quoteModal'); if(quoteModal) quoteModal.addEventListener('click', function(e){ if(e.target===this) closeQuote(); });
  var qPrint=document.getElementById('qPrint'); if(qPrint) qPrint.addEventListener('click', function(){ window.print(); });
  var qBuy=document.getElementById('qBuy'); if(qBuy) qBuy.addEventListener('click', function(){ closeQuote(); var a=document.getElementById('atcMain'); if(a) a.click(); });

  updOvSize(); drawScale();

  // ===== Nette custom dropdowns: gebouwd uit de bestaande selects (logica blijft) =====
  (function(){
    var grids=document.querySelectorAll('.confgrid'); if(!grids.length) return;
    function esc(s){ return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
    function build(sel){
      var row=sel.closest('.confrow'); if(!row) return;
      var dd=document.createElement('div'); dd.className='dd'; dd.tabIndex=0;
      var cur=sel.options[sel.selectedIndex]?sel.options[sel.selectedIndex].textContent:'';
      var items='';
      for(var i=0;i<sel.options.length;i++){
        items+='<li data-i="'+i+'"'+(i===sel.selectedIndex?' class="on"':'')+'><span>'+esc(sel.options[i].textContent)+'</span><em class="dx"></em><svg class="ck" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg></li>';
      }
      dd.innerHTML='<span class="dd-val">'+esc(cur)+'</span>'+(sel.id==='selSize'?'<span class="dd-edit">Change</span>':'')+'<svg class="ddchev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg><ul class="dd-menu">'+items+'</ul>';
      row.appendChild(dd);
      var valEl=dd.querySelector('.dd-val'), menu=dd.querySelector('.dd-menu');
      sel.addEventListener('change', function(){
        valEl.textContent=sel.options[sel.selectedIndex].textContent;
        menu.querySelectorAll('li').forEach(function(x){ x.classList.toggle('on', +x.dataset.i===sel.selectedIndex); });
      });
      dd.addEventListener('click', function(e){
        if(e.target.closest('.dd-menu')) return;
        var wasOpen=dd.classList.contains('open'); closeAll();
        if(!wasOpen){ dd.classList.add('open'); if(window.ddOnOpen && ddOnOpen[sel.id]) ddOnOpen[sel.id](menu, sel); }
      });
      dd.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); dd.click(); } });
      menu.addEventListener('click', function(e){
        var li=e.target.closest('li'); if(!li) return;
        var idx=parseInt(li.dataset.i,10);
        sel.selectedIndex=idx; sel.dispatchEvent(new Event('change',{bubbles:true}));
        valEl.textContent=sel.options[idx].textContent;
        menu.querySelectorAll('li').forEach(function(x){x.classList.remove('on')}); li.classList.add('on');
        dd.classList.remove('open');
      });
    }
    function closeAll(){ document.querySelectorAll('.confrow .dd.open').forEach(function(d){d.classList.remove('open')}); }
    grids.forEach(function(g){ g.querySelectorAll('select').forEach(build); g.classList.add('dd-ready'); });
    document.addEventListener('click', function(e){ if(!e.target.closest('.confrow .dd')) closeAll(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAll(); });
  })();


  // Colour dots for rows that come from the description (builder creations, 1 Nov 2026)
  document.querySelectorAll('.dupv2 [data-nsf-sw]').forEach(function(el){ try { el.outerHTML = colorSwatchHtml(el.getAttribute('data-nsf-sw'), 'dot'); } catch (e) {} });
  window.__ready=true;

  // Onderbalk: samenvatting van de keuze + direct bestellen
  (function(){
    var sum=document.getElementById('stickySum'); if(!sum) return;
    // Guard: products without a size or colour option have an empty select; this used to throw before the sticky button was wired (31 Oct 2026)
    function t(id){ var s=document.getElementById(id), o=s && s.options[s.selectedIndex]; return o ? (o.dataset.size||o.textContent).replace(/\s*\(\+\d+%\)/,'') : ''; }
    function upd(){ sum.textContent=[t('selSize'), t('selColor')].filter(Boolean).join(' · '); }
    document.addEventListener('change', function(e){ if(e.target.closest && e.target.closest('.optlist')) upd(); });
    upd();
    document.getElementById('stickyAtc').addEventListener('click', function(){
      document.getElementById('atcMain').click();
    });
  })();

  // Keuzelijst: gekozen waarde tonen in de rij (de select ligt onzichtbaar over de rij)
  function syncVals(){
    document.querySelectorAll('.oval[data-for]').forEach(function(el){
      var s=document.getElementById(el.dataset.for);
      if(!s || !s.options || !s.options.length){ el.textContent=''; return; }
      if(s.selectedIndex < 0) s.selectedIndex = 0;
      var o=s.options[s.selectedIndex]; if(!o) return;
      var label = o.dataset.size || o.textContent;
      if(el.dataset.for==='selColor'){
        // RGB / multi-colour: proper swatch (not a single wrong pink dot)
        el.innerHTML = colorSwatchHtml(o.textContent || o.value || '', 'dot') +
          '<span class="cval-txt">'+(label || '').replace(/\s*\(\+?\d+%\)\s*$/,'')+'</span>';
      } else {
        el.textContent = label;
      }
    });
  }
  // Prijsverschil per maat in de keuzelijst van het toestel
  function updDeltas(){
    return; // prijsverschil staat nu in de eigen keuzelijst
    var s=document.getElementById('selSize'); if(!s || !window.shownFor) return;
    var cur=shownFor(parseFloat(s.selectedOptions[0].dataset.add||0));
    for(var i=0;i<s.options.length;i++){
      var o=s.options[i], d=shownFor(parseFloat(o.dataset.add||0))-cur;
      o.textContent = o.dataset.size + (i===s.selectedIndex ? '' : '   ('+(d>0?'+':'−')+moneyDelta(d)+')');
    }
  }
  // Maat: kleiner/groter-knoppen + klein schaalplaatje
  function drawMini(){
    var svg=document.getElementById('miniScale'); if(!svg) return;
    var o=document.getElementById('selSize').selectedOptions[0]; if(!o) return; // no size option on this product (31 Oct 2026)
    var w=+o.dataset.w, h=+o.dataset.h, fl=68;
    var ch=Math.max(165, 95+h/2), k=Math.min(.29, 64/Math.max(180, ch+h/2), 100/(w+60));   // zoom out for big signs
    var bw=w*k, bh=h*k, cy=fl-ch*k, cx=Math.min(Math.max(76, 24+bw/2), 118-bw/2);
    svg.innerHTML='<line x1="0" x2="120" y1="'+fl+'" y2="'+fl+'" stroke="#e3dfee" stroke-width="1"/>'+
      '<g fill="#b8b1cf"><circle cx="11" cy="'+(fl-170*k)+'" r="'+(11*k)+'"/><rect x="'+(11-15*k)+'" y="'+(fl-155*k)+'" width="'+(30*k)+'" height="'+(62*k)+'" rx="'+(10*k)+'"/><rect x="'+(11-12*k)+'" y="'+(fl-100*k)+'" width="'+(11*k)+'" height="'+(100*k)+'" rx="1.4"/><rect x="'+(11+1*k)+'" y="'+(fl-100*k)+'" width="'+(11*k)+'" height="'+(100*k)+'" rx="1.4"/></g>'+
      '<g fill="#d9cfc2"><rect x="'+(cx-100*k)+'" y="'+(fl-85*k)+'" width="'+(200*k)+'" height="'+(44*k)+'" rx="3"/><rect x="'+(cx-104*k)+'" y="'+(fl-46*k)+'" width="'+(208*k)+'" height="'+(26*k)+'" rx="2.5"/></g>'+
      '<rect x="'+(cx-bw/2)+'" y="'+(cy-bh/2)+'" width="'+bw+'" height="'+bh+'" rx="1.5" fill="#fff2f8" stroke="#ff2d92" stroke-width="1.2"/>';
  }
  function updStep(){
    var s=document.getElementById('selSize');
    if(!s || !s.options.length){ syncScaleCtrl(); return; }
    var zm=document.getElementById('szMinus'), zp=document.getElementById('szPlus');
    if(zm) zm.disabled = s.selectedIndex<=0;
    if(zp) zp.disabled = s.selectedIndex>=s.options.length-1;
    var sb=document.querySelectorAll('.sc-btn'); if(sb.length){ sb[0].disabled=s.selectedIndex<=0; sb[1].disabled=s.selectedIndex>=s.options.length-1; }
    syncScaleCtrl();
  }
  function stepSize(d){
    var s=document.getElementById('selSize'), i=s.selectedIndex+d; if(i<0||i>=s.options.length) return;
    s.selectedIndex=i; s.dispatchEvent(new Event('change',{bubbles:true}));
  }
  var szMinus=document.getElementById('szMinus'); if(szMinus) szMinus.addEventListener('click', function(){ stepSize(-1); });
  document.querySelectorAll('.sc-btn').forEach(function(b){ b.addEventListener('click', function(e){ e.stopPropagation(); stepSize(+b.dataset.step); }); });
  var szPlus=document.getElementById('szPlus'); if(szPlus) szPlus.addEventListener('click', function(){ stepSize(1); });
  var szScale=document.getElementById('szScale'); if(szScale) szScale.addEventListener('click', function(){
    document.querySelector('#thumbs .thumb-scale').click();
    if(window.innerWidth<=1000) document.querySelector('.stage').scrollIntoView({behavior:'smooth', block:'start'});
  });

  // ===== Eigen keuzelijst (paneel van onderen op mobiel, uitklaplijst op desktop) =====
  // Same as custom_neon: RGB / multi subtitles + +25% via locale-aware isRgbColorLabel
  function colorSubLabel(label){
    // Theme settings only — never inject English copy on other stores
    if(isRgbColorLabel(label)) return CFG.colorSubRgb || '';
    var n=splitColorParts(label).length;
    if(n<=1) return CFG.colorSubOne || '';
    return CFG.colorSubMulti ? tpl(CFG.colorSubMulti, { n: n }) : '';
  }
  var PK = { selColor: { sub:[], right:[], vis:[] } };
  (function(){
    var s=document.getElementById('selColor');
    if(s && s.options.length){
      PK.selColor.sub=[]; PK.selColor.right=[]; PK.selColor.vis=[];
      for(var i=0;i<s.options.length;i++){
        var txt=s.options[i].textContent||s.options[i].value||'';
        PK.selColor.sub.push(colorSubLabel(txt));
        PK.selColor.right.push(isRgbColorLabel(txt) || /\+?\s*25\s*%/i.test(txt) ? '+25%' : '');
        PK.selColor.vis.push(colorSwatchHtml(txt, 'tile'));
      }
    }
  })();
  function cablePoint(i){ // Midden onder, Midden boven, Rechtsonder, Rechtsboven, Linksonder, Linksboven
    var x=[15,15,24,24,6,6][i], y=[17,3,17,3,17,3][i], ly=y>10?20:0;
    return '<svg class="pk-board" viewBox="0 0 30 20"><rect x="1" y="3" width="28" height="14" rx="2.5"/><line x1="'+x+'" y1="'+y+'" x2="'+x+'" y2="'+ly+'" class="pk-cable"/><circle cx="'+x+'" cy="'+y+'" r="2.4"/></svg>';
  }
  function sizeBar(o){ var w=6+(+o.dataset.w-40)/210*30, h=Math.max(3,w/2); return '<svg class="pk-size" viewBox="0 0 36 18"><rect x="'+(18-w/2)+'" y="'+(9-h/2)+'" width="'+w+'" height="'+h+'" rx="1.5"/></svg>'; }

  function syncMediaStickyForPicker(row){
    var root = document.querySelector('.dupv2');
    if (!root) return;
    var rows = root.querySelectorAll('#optlist .orow:not(.orow-static)');
    var last = rows.length ? rows[rows.length - 1] : null;
    var isLastOpen = !!(pkSel && row && last && row === last);
    root.classList.toggle('picker-open-last', isLastOpen);
  }
  // Any description accordion open → left media unsticks
  (function(){
    var root = document.querySelector('.dupv2');
    if (!root) return;
    var descs = root.querySelectorAll('.desc-stack .descbox');
    if (!descs.length) return;
    function syncDescSticky(){
      var open = false;
      for (var i = 0; i < descs.length; i++) {
        if (descs[i].open) { open = true; break; }
      }
      root.classList.toggle('desc-open', open);
    }
    syncDescSticky();
    descs.forEach(function(desc){ desc.addEventListener('toggle', syncDescSticky); });
  })();
  var pkSel=null;
  function openPicker(sel, row){
    if(!sel || !row) return;
    pkSel=sel;
    var cfg=PK[sel.id]||{help:sel.dataset.help||''}, list=document.getElementById('pkList'), h='';
    if(!list) return;
    var cur = 0;
    try { if(sel.id==='selSize' && sel.selectedOptions[0]) cur = shownFor(parseFloat(sel.selectedOptions[0].dataset.add||0)); } catch(e){}
    for(var i=0;i<sel.options.length;i++){
      var o=sel.options[i], label=o.dataset.size||o.textContent.replace(/\s*\(\+\d+%\)/,''), vis='', sub=(cfg.sub||[])[i]||'', right=(cfg.right||[])[i]||'', rc='';
      if(sel.id==='selSize'){ try{vis=sizeBar(o);}catch(e){vis='';} if(i!==sel.selectedIndex){ try{ var d=shownFor(parseFloat(o.dataset.add||0))-cur; right=(d>0?'+':'−')+moneyDelta(d); rc=d<0?' neg':''; }catch(e2){} } }
      else if(sel.id==='selColor'){
        var src=colorOptionImage(o,240);
        var cLabel=o.textContent||o.value||'';
        // Prefer variant photo; else RGB/multi/single swatch (never wrong solid pink for multi)
        vis=src
          ? '<img class="pk-photo" src="'+src+'" alt="">'
          : colorSwatchHtml(cLabel, 'tile');
      }
      else if(sel.id==='selStroom' && typeof cablePoint==='function') vis=cablePoint(i);
      else if(cfg.vis) vis=cfg.vis[i];
      h+='<li class="pk-opt'+(i===sel.selectedIndex?' on':'')+'" data-i="'+i+'" role="option" tabindex="0">'+
         (vis?'<span class="pk-vis">'+vis+'</span>':'')+
         '<span class="pk-txt"><span class="pk-l">'+label+'</span>'+(sub?'<span class="pk-s">'+sub+'</span>':'')+'</span>'+
         (right?'<span class="pk-r'+rc+'">'+right+'</span>':'')+
         '<svg class="pk-ck" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg></li>';
    }
    list.innerHTML=h;
    var hp=document.getElementById('pkHelp'); if(hp){ hp.innerHTML=cfg.help?'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg><span>'+cfg.help+'</span>':''; hp.style.display=cfg.help?'':'none'; }
    var title=row.querySelector('.ol').childNodes[0].textContent.trim();
    var pkTitle=document.getElementById('pkTitle'); if(pkTitle) pkTitle.textContent=title;
    var pk=document.getElementById('picker'), box=document.getElementById('optlist');
    if(!pk) return;
    pk.style.top = (row.offsetTop+row.offsetHeight+4)+'px';
    pk.classList.add('open'); var pkb=document.getElementById('pkBackdrop'); if(pkb) pkb.classList.add('open');
    document.documentElement.classList.add('dupv2-picker-open');
    document.body.classList.add('dupv2-picker-open');
    var on=list.querySelector('.on'); if(on) on.scrollIntoView({block:'nearest'});
    syncMediaStickyForPicker(row);
  }
  function closePicker(){
    var pk=document.getElementById('picker'); if(pk) pk.classList.remove('open');
    var pkb=document.getElementById('pkBackdrop'); if(pkb) pkb.classList.remove('open');
    document.documentElement.classList.remove('dupv2-picker-open');
    document.body.classList.remove('dupv2-picker-open');
    pkSel=null;
    syncMediaStickyForPicker(null);
  }
  function choose(li){ if(!pkSel||!li) return; pkSel.selectedIndex=+li.dataset.i; pkSel.dispatchEvent(new Event('change',{bubbles:true})); closePicker(); }
  var pkListEl=document.getElementById('pkList');
  if(pkListEl){
    pkListEl.addEventListener('click', function(e){ choose(e.target.closest('.pk-opt')); });
    pkListEl.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); choose(e.target.closest('.pk-opt')); } });
  }
  var pkCloseEl=document.getElementById('pkClose'); if(pkCloseEl) pkCloseEl.addEventListener('click', closePicker);
  var pkBackdropEl=document.getElementById('pkBackdrop'); if(pkBackdropEl) pkBackdropEl.addEventListener('click', closePicker);
  document.addEventListener('click', function(e){ if(pkSel && !e.target.closest('#picker') && !e.target.closest('.orow')) closePicker(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closePicker(); });
  // rijen openen de lijst
  document.querySelectorAll('#optlist .orow').forEach(function(row){
    if(row.classList.contains('orow-static')) return;
    var trigger = row.classList.contains('orow-size') ? row.querySelector('.sz-val') : row;
    var sel = row.querySelector('select'); if(!sel) return;
    trigger.setAttribute('role','button'); trigger.tabIndex=0;
    trigger.addEventListener('click', function(e){
      if(e.target.closest('.oinfo')) return;
      e.stopPropagation();
      if(pkSel===sel){ closePicker(); return; }
      openPicker(sel, row);
    });
    trigger.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); trigger.click(); } });
  });

  // ===== Info tips (Theme Editor blocks) =====
  function normalizeInfoKey(raw){
    var k=(raw||'').toString().trim().toLowerCase();
    if(!k) return '';
    // Backboard — EN NL FR IT SE ES DK DE PT
    if(k==='cut to shape' || k==='backboard' || k==='pannello' || k.indexOf('taglio')!==-1
      || k==='op maat' || k.indexOf('op maat')!==-1 || k==='achterplaat' || k==='acrylaat'
      || k==='decoupe' || k==='découpe' || k.indexOf('forme')!==-1 || k==='panneau'
      || k.indexOf('support')!==-1 || k.indexOf('arrière')!==-1 || k.indexOf('arriere')!==-1
      || k==='skuren' || k==='skräddarsydd' || k==='akrylplatta' || k==='bakplatta'
      || k==='recorte' || k==='placa' || k==='zuschnitt' || k==='rueckwand' || k==='rückwand'
      || k==='tilpasset' || k==='udskaaret' || k==='udskåret' || k.indexOf('vorm')!==-1
      || k.indexOf('formgeschnitten')!==-1 || k.indexOf('utskuren')!==-1) return 'backboard';
    // Colour — EN NL FR IT SE ES DK DE PT
    if(k==='color' || k==='colour' || k==='colore' || k==='kleur' || k==='couleur'
      || k==='färg' || k==='farg' || k==='farbe' || k==='farve' || k==='farver'
      || k==='colores' || k==='kleuren' || k==='farben' || k==='cor' || k==='cores'
      || k==='couleur' || k==='kleur(en)') return 'colour';
    if(k==='uv print' || k==='uv-print' || k==='uvprint' || k==='stampa uv'
      || k==='impressao uv' || k==='impressão uv' || k==='uv-druk' || k==='uv druk'
      || k==='impression uv' || k==='uv-druck' || k==='uv tryck' || k==='uv-print') return 'uv print';
    // Delivery — EN(UK/USA) NL FR IT SE ES DK DE PT
    if(k==='delivery' || k==='levering' || k==='livraison' || k==='consegna'
      || k==='leverans' || k==='entrega' || k==='lieferung' || k==='versand'
      || k==='expedicao' || k==='expedição' || k==='envio' || k==='envío'
      || k==='verzending' || k==='leveringstid' || k==='livraison') return 'delivery';
    return k;
  }
  function isColourTip(t){
    if (!t) return false;
    if (normalizeInfoKey(t.match)==='colour') return true;
    // Truthy checks only — never treat explicit null JSON fields as colour tips
    if (t.gridHeading || t.pickerNote) return true;
    if (t.answerOne || t.answerMulti || t.answerRgb) return true;
    if (t.videos || t.videoLabels) return true;
    return false;
  }
  function tipHasBody(t){
    if (!t) return false;
    if (t.answer || t.note || t.fact1 || t.fact2) return true;
    if (t.answerOne || t.answerMulti || t.answerRgb) return true;
    if (t.gridHeading || t.pickerNote || t.videos) return true;
    if (t.illustration && t.illustration !== 'none') return true;
    if (t.figureImage || t.figureCaption) return true;
    if (t.step1Title || t.step2Title || t.step3Title) return true;
    return false;
  }
  function findInfoTip(key){
    var tips=CFG.infoTips||[];
    var nk=normalizeInfoKey(key);
    var keyL=String(key||'').toLowerCase().trim();
    var colourName=OPT_COLOR ? String(OPT_COLOR.name||'').toLowerCase().trim() : '';
    var colourCfg=String(CFG.colourOptionName||'').toLowerCase().trim();
    for(var i=0;i<tips.length;i++){
      if(normalizeInfoKey(tips[i].match)===nk) return tips[i];
      if(keyL && String(tips[i].match||'').toLowerCase().trim()===keyL) return tips[i];
    }
    if (nk==='backboard') {
      for (var b=0;b<tips.length;b++) {
        if (tips[b].illustration==='backboard' || normalizeInfoKey(tips[b].match)==='backboard') return tips[b];
      }
    }
    if (nk==='colour' || (colourName && keyL===colourName) || (colourCfg && keyL===colourCfg)) {
      for (var j=0;j<tips.length;j++) {
        if (isColourTip(tips[j])) return tips[j];
      }
    }
    if (nk==='delivery') {
      for (var d=0;d<tips.length;d++) {
        if (tips[d].illustration==='delivery' || normalizeInfoKey(tips[d].match)==='delivery') return tips[d];
      }
    }
    // Last resort: any tip whose match/label normalizes to the same key family
    for (var t=0;t<tips.length;t++) {
      if (tips[t].illustration && normalizeInfoKey(tips[t].illustration)===nk) return tips[t];
    }
    return null;
  }
  function infoPlaceholders(tip){
    syncDeliveryDays();
    // {days}/{min}/{max} = numbers from Theme settings → delivery_days_offset only (never calendar ETA).
    // Words like "working days" belong in editable tip Answer / Fact / Step 3 sub text.
    var oneTpl=(tip&&tip.daysOneTpl)||CFG.daysOneTpl||'{n}';
    var rangeTpl=(tip&&tip.daysRangeTpl)||CFG.daysRangeTpl||'{min}–{max}';
    var days=DELIVERY_MIN===DELIVERY_MAX
      ? tpl(oneTpl,{n:DELIVERY_MIN})
      : tpl(rangeTpl,{min:DELIVERY_MIN,max:DELIVERY_MAX});
    var etaEl=document.getElementById('eta');
    var eta=etaEl&&etaEl.textContent?etaEl.textContent.trim():'';
    // {between}/{eta} = calendar dates on the PDP card; tip copy that needs the static range should use {days}
    var between=eta
      ? eta.replace(/\u2013/g, ' '+listRangeWord()+' ').replace(/ to /gi, ' '+listAndWord()+' ')
      : days;
    return {eta:eta||days, between:between, days:days, min:DELIVERY_MIN, max:DELIVERY_MAX};
  }
  function storeLang(){
    var lang = (CFG.locale || document.documentElement.lang || (window.Shopify && Shopify.locale) || '').toLowerCase();
    return String(lang).split(/[-_]/)[0] || 'en';
  }
  function listAndWord(override){
    var fromTip = override != null ? String(override).trim() : '';
    if (fromTip) return fromTip;
    var fromCfg = CFG.listAndWord != null ? String(CFG.listAndWord).trim() : '';
    if (fromCfg) return fromCfg;
    var map = { nl:'en', de:'und', fr:'et', it:'e', es:'y', pt:'e', sv:'och', se:'och', da:'og', dk:'og', en:'and' };
    return map[storeLang()] || 'and';
  }
  function listRangeWord(){
    var map = { nl:'tot', de:'bis', fr:'à', it:'a', es:'a', pt:'a', sv:'till', se:'till', da:'til', dk:'til', en:'to' };
    return map[storeLang()] || 'to';
  }
  function splitCsv(raw){
    return String(raw==null?'':raw).split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  }
  var INFO_SVG={
    bag:'<svg viewBox="0 0 24 24"><path d="M3 6h18l-2 12H5z"/><path d="M9 10v4M15 10v4"/></svg>',
    tools:'<svg viewBox="0 0 24 24"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.9 2.9-2-2z"/></svg>',
    truck:'<svg viewBox="0 0 24 24"><path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7"/><circle cx="5.5" cy="18.5" r="1.8"/><circle cx="17.5" cy="18.5" r="1.8"/></svg>',
    star:'<svg viewBox="0 0 24 24"><path d="M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5z"/></svg>',
    clock:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    feather:'<svg viewBox="0 0 24 24"><path d="M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5z"/></svg>',
    split:'<svg viewBox="0 0 24 24"><rect x="3" y="6" width="8" height="12" rx="1.5"/><rect x="13" y="6" width="8" height="12" rx="1.5"/></svg>'
  };
  function infoIconHtml(url, fallbackSvg){
    if(url) return '<img src="'+url+'" alt="" width="16" height="16" loading="lazy">';
    return fallbackSvg||INFO_SVG.star;
  }
  function infoIllustration(tip, map){
    var caption=tip&&tip.figureCaption;
    var kind=tip&&tip.illustration;
    var cap=caption ? '<div class="is-figcap">'+tpl(caption, map||{})+'</div>' : '';
    if(tip&&tip.figureImage){
      return '<div class="is-figure"><img class="is-figimg" src="'+tip.figureImage+'" alt="" loading="lazy">'+cap+'</div>';
    }
    if(kind==='backboard'){
      return '<div class="is-figure"><svg viewBox="0 0 260 130" class="is-ill"><rect x="0" y="0" width="260" height="130" rx="10" class="wall"/><path class="plate" d="M52 70c0-24 18-38 40-38c15 0 22 8 30 8s14-10 34-10c22 0 40 14 40 36c0 24-18 36-40 36H92c-24 0-40-12-40-32z"/><text x="130" y="80" class="tube">logo</text><path class="callout" d="M200 50l26-18"/><text x="250" y="24" class="cap" text-anchor="end">acrylic board</text><path class="callout" d="M150 92l30 22"/><text x="183" y="124" class="cap">LED neon</text></svg>'+cap+'</div>';
    }
    if(kind==='uv'){
      return '<div class="is-figure"><svg viewBox="0 0 260 130" class="is-ill"><rect x="0" y="0" width="260" height="130" rx="10" class="wall"/><rect x="50" y="22" width="160" height="86" rx="8" class="plate"/><text x="130" y="68" class="tube">CAFÉ</text><text x="130" y="90" class="print">since 2026 · coffee &amp; more</text><path class="callout" d="M188 46l26-20"/><text x="252" y="20" class="cap" text-anchor="end">neon: lights up</text><path class="callout" d="M168 94l12 18"/><text x="252" y="124" class="cap" text-anchor="end">UV print: does not light up</text></svg>'+cap+'</div>';
    }
    if(kind==='delivery'){
      // Block / CFG copy only — no English hardcodes (NL/FR/IT/… use theme editor text)
      var s1t=tip.step1Title||CFG.deliveryStep1Title||'';
      var s1s=tip.step1Sub||CFG.deliveryStep1Sub||'';
      var s2t=tip.step2Title||CFG.deliveryStep2Title||'';
      var s2s=tip.step2Sub||CFG.deliveryStep2Sub||'';
      var s3t=tip.step3Title||CFG.deliveryStep3Title||'';
      var s3s=tpl((tip&&tip.step3Sub)||CFG.deliveryStep3Sub||'{days}', map||{});
      return '<div class="is-figure is-tl"><div class="dtl">'+
        '<div class="dtl-st on"><span class="dtl-dot">'+infoIconHtml(tip.step1Icon, INFO_SVG.bag)+'</span><b>'+s1t+'</b><span>'+s1s+'</span></div>'+
        '<div class="dtl-st"><span class="dtl-dot">'+infoIconHtml(tip.step2Icon, INFO_SVG.tools)+'</span><b>'+s2t+'</b><span>'+s2s+'</span></div>'+
        '<div class="dtl-st end"><span class="dtl-dot">'+infoIconHtml(tip.step3Icon, INFO_SVG.truck)+'</span><b>'+s3t+'</b><span>'+s3s+'</span></div>'+
      '</div></div>';
    }
    return '';
  }
  function colorLibrary(tip){
    var vids=splitCsv(tip.videos), labels=splitCsv(tip.videoLabels), imgs=splitCsv(tip.videoImages);
    var lib={};
    for(var i=0;i<Math.max(vids.length, labels.length);i++){
      var name=labels[i]||'';
      if(!name && !vids[i]) continue;
      var entry={ label:name, video:vids[i]||'', image:imgs[i]||'' };
      var aliases = [
        String(name || '').toLowerCase(),
        foldColorToken(name),
        colorCanonKey(name)
      ];
      for (var a = 0; a < aliases.length; a++) {
        if (aliases[a] && !lib[aliases[a]]) lib[aliases[a]] = entry;
      }
    }
    return lib;
  }
  function parseDesignColors(design){
    return splitColorParts(design);
  }
  function productHasRgbOrMulti(sel){
    if(!sel || !sel.options) return false;
    for(var i=0;i<sel.options.length;i++){
      var t=sel.options[i].textContent||sel.options[i].value||'';
      if(isRgbColorLabel(t)) return true;
      if(parseDesignColors(t).length>1) return true;
    }
    return false;
  }
  function formatColorList(parts, andOverride){
    if(!parts.length) return '';
    if(parts.length===1) return parts[0];
    var and = listAndWord(andOverride);
    if(parts.length===2) return parts[0]+' '+and+' '+parts[1];
    return parts.slice(0,-1).join(', ')+' '+and+' '+parts[parts.length-1];
  }
  function findColorLibEntry(lib, name){
    if (!lib || !name) return null;
    var key = String(name || '').toLowerCase();
    if (lib[key]) return lib[key];
    var fold = foldColorToken(name);
    if (fold && lib[fold]) return lib[fold];
    var canon = colorCanonKey(name);
    if (canon && lib[canon]) return lib[canon];
    var keys = Object.keys(lib);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (key.indexOf(k) !== -1 || k.indexOf(key) !== -1) return lib[k];
      if (fold && (fold.indexOf(k) !== -1 || k.indexOf(fold) !== -1)) return lib[k];
      if (canon && (colorCanonKey(k) === canon || foldColorToken(k) === canon)) return lib[k];
    }
    return null;
  }
  function buildColorTiles(parts, lib){
    var tiles='', n=0;
    parts.forEach(function(name){
      var entry=findColorLibEntry(lib, name);
      var label=name || (entry&&entry.label) || '';
      var video=entry&&entry.video||'';
      var img=entry&&entry.image||'';
      tiles+='<button type="button" class="is-color'+(video?'':' is-nocol')+'"'+(video?' data-video="'+video+'"':'')+'>';
      if(img) tiles+='<img src="'+img+'" alt="'+label.replace(/"/g,'')+'">';
      tiles+='<span class="is-cname">'+label+'</span>';
      if(video) tiles+='<span class="is-play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>';
      tiles+='</button>';
      n++;
    });
    return n ? '<div class="is-colors'+(n===1?' one':'')+'">'+tiles+'</div>' : '';
  }
  function buildRgbSection(tip, rgbIndex){
    if(rgbIndex<0) return '';
    if(!(tip.sectionHeading||tip.sectionText||tip.sectionVideo||tip.sectionButton)) return '';
    var h='<div class="is-sec"><div class="is-sec-row"><div>';
    if(tip.sectionHeading) h+='<div class="is-sec-h">'+tip.sectionHeading+'</div>';
    if(tip.sectionText) h+='<p class="is-p">'+tip.sectionText+'</p>';
    h+='</div>';
    if(tip.sectionButton) h+='<button type="button" class="is-switch is-switch-sm" data-color="'+rgbIndex+'">'+tip.sectionButton+'</button>';
    h+='</div>';
    if(tip.sectionVideo) h+='<video class="is-video is-video-sm" src="'+tip.sectionVideo+'" autoplay muted loop playsinline></video>';
    h+='</div>';
    return h;
  }
  // Collection PDP colour modal — same layout as neonsfeer-collectie-productpagina.html (cs-*)
  function csPhStyle(label){
    var hexes=colorLabelHexes(label);
    if(hexes[0]==='__rgb__') return 'background:conic-gradient(#ff3b3b,#ffd23b,#3bff6b,#3bd2ff,#6b3bff,#ff3bd2,#ff3b3b)';
    if(hexes.length>1){
      var stops=hexes.slice(0,4).map(function(h,i,a){
        var a0=(i/a.length*100).toFixed(1), a1=((i+1)/a.length*100).toFixed(1);
        return h+' '+a0+'%, '+h+' '+a1+'%';
      }).join(', ');
      return 'background:linear-gradient(135deg,'+stops+')';
    }
    return 'background:'+(hexes[0]||'#e8e4f0');
  }
  function buildColourInfoHtml(tip){
    tip = tip || {};
    var sel=document.getElementById('selColor');
    if(!sel || !sel.options.length) return '';
    var cur=sel.selectedOptions[0] || sel.options[0];
    var name=cur ? (cur.textContent||cur.value||'') : '';
    var n=sel.options.length;
    var map={ n:n, color:name };

    // Match collectie HTML: always show OK ("Choose {color}" / store label)
    var okEl=document.getElementById('isOk');
    if(okEl){
      var okTpl=tip.okChoose||tip.okLabel||'';
      var okTxt=okTpl ? tpl(okTpl, map) : name;
      // If template still has an unresolved {color}, fall back to colour name
      if(!okTxt || /\{color\}/i.test(okTxt)) okTxt = name || okTpl.replace(/\{color\}/ig, name);
      okEl.textContent=okTxt||'Got it';
      okEl.style.display='';
    }

    // HTML colour modal: hero preview + swatch grid + note (no separate RGB essay layout)
    var mainSrc=colorOptionImage(cur, 900);
    var mainFallbackStyle=csPhStyle(name);
    var main=mainSrc
      ? '<img src="'+mainSrc+'" alt="'+String(name).replace(/"/g,'')+'" onerror="this.style.display=\'none\'">'
      : '<div class="cs-main-fallback" style="'+mainFallbackStyle+'"></div>';
    var tagSwatch=colorSwatchHtml(name, 'dot');
    var gridClass='cs-grid'+(n<=2?' cs-grid--few':(n<=4?' cs-grid--mid':''));
    var grid='<div class="'+gridClass+'">'+[].map.call(sel.options,function(o){
      var label=String(o.textContent||o.value||'').replace(/"/g,'');
      var src=colorOptionImage(o,240);
      var phStyle=csPhStyle(label);
      var ph=src
        ? '<img src="'+src+'" alt="" loading="lazy" onerror="this.style.display=\'none\'">'
        : '';
      return '<button type="button" class="cs-c'+(o.selected?' on':'')+'" data-pick="'+o.index+'" style="--c:'+colorOptionHex(o)+'"><span class="cs-ph" style="'+phStyle+'">'+ph+'</span><span class="cs-n">'+label+'</span></button>';
    }).join('')+'</div>';
    var headingTpl=tip.gridHeading||'';
    var noteCol=tip.pickerNote||tip.noteOne||tip.note||'';
    return '<div class="cs-main">'+main+'<span class="cs-tag">'+tagSwatch+' '+name+'</span></div>'+
      (headingTpl ? '<p class="cs-h">'+tpl(headingTpl, map)+'</p>' : '')+grid+
      (noteCol ? '<p class="cs-note">'+tpl(noteCol, map)+'</p>' : '');
  }
  function buildInfoHtml(tip){
    var map=infoPlaceholders(tip);
    if(tip.content) return tpl(tip.content, map);
    if(normalizeInfoKey(tip.match)==='colour' || isColourTip(tip)) return buildColourInfoHtml(tip);
    var h='';
    if(tip.answer) h+='<p class="is-answer">'+tpl(tip.answer, map)+'</p>';
    if(tip.note) h+='<p class="is-p" style="margin:-6px 0 12px">'+tpl(tip.note, map)+'</p>';
    var vids=splitCsv(tip.videos), labels=splitCsv(tip.videoLabels), imgs=splitCsv(tip.videoImages);
    if(vids.length){
      var tiles='';
      for(var i=0;i<vids.length;i++){
        var label=labels[i]||('Colour '+(i+1));
        var img=imgs[i]||'';
        tiles+='<button type="button" class="is-color" data-video="'+vids[i]+'">';
        if(img) tiles+='<img src="'+img+'" alt="'+label.replace(/"/g,'')+'">';
        tiles+='<span class="is-cname">'+label+'</span><span class="is-play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span></button>';
      }
      h+='<div class="is-colors'+(vids.length===1?' one':'')+'">'+tiles+'</div>';
    }
    h+=infoIllustration(tip, map);
    var tipFacts=[];
    if(tip.fact1) tipFacts.push({ text:tpl(tip.fact1, map), icon:tip.fact1Icon, fallback: normalizeInfoKey(tip.match)==='delivery' ? INFO_SVG.star : INFO_SVG.feather });
    if(tip.fact2) tipFacts.push({ text:tpl(tip.fact2, map), icon:tip.fact2Icon, fallback: normalizeInfoKey(tip.match)==='delivery' ? INFO_SVG.clock : INFO_SVG.split });
    if(tipFacts.length){
      h+='<div class="is-facts">'+tipFacts.map(function(f){
        return '<div class="is-fact"><span class="is-fi">'+infoIconHtml(f.icon, f.fallback)+'</span><span>'+f.text+'</span></div>';
      }).join('')+'</div>';
    }
    if(tip.sectionHeading||tip.sectionText||tip.sectionVideo||tip.sectionButton){
      h+='<div class="is-sec"><div class="is-sec-row"><div>';
      if(tip.sectionHeading) h+='<div class="is-sec-h">'+tpl(tip.sectionHeading, map)+'</div>';
      if(tip.sectionText) h+='<p class="is-p">'+tpl(tip.sectionText, map)+'</p>';
      h+='</div>';
      if(tip.sectionButton) h+='<button type="button" class="is-switch is-switch-sm" data-color="1">'+tip.sectionButton+'</button>';
      h+='</div>';
      if(tip.sectionVideo) h+='<video class="is-video is-video-sm" src="'+tip.sectionVideo+'" autoplay muted loop playsinline></video>';
      h+='</div>';
    }
    return h;
  }
  /** Theme Editor blocks only — never inject English fallback copy (other stores use their own language). */
  function resolveInfoTip(key){
    var tip=findInfoTip(key);
    if(tip) return tip;
    var nk=normalizeInfoKey(key);
    if(nk){
      tip=findInfoTipByType(nk);
      if(tip) return tip;
    }
    // Heuristic: match tip by illustration / colour tip shape when label is store-specific
    var tips=CFG.infoTips||[];
    var keyL=String(key||'').toLowerCase().trim();
    for(var i=0;i<tips.length;i++){
      var m=String(tips[i].match||'').toLowerCase().trim();
      var title=String(tips[i].title||'').toLowerCase().trim();
      if(keyL && (m===keyL || title===keyL || m.indexOf(keyL)!==-1 || keyL.indexOf(m)!==-1)) return tips[i];
    }
    if(tips.length===1) return tips[0];
    return null;
  }
  function findInfoTipByType(type){
    var tips=CFG.infoTips||[];
    var i;
    if(!type) return null;
    if(type==='delivery'){
      for(i=0;i<tips.length;i++){
        if(tips[i].illustration==='delivery' || normalizeInfoKey(tips[i].match)==='delivery') return tips[i];
      }
    }
    if(type==='backboard'){
      for(i=0;i<tips.length;i++){
        if(tips[i].illustration==='backboard' || normalizeInfoKey(tips[i].match)==='backboard') return tips[i];
      }
    }
    if(type==='colour'){
      for(i=0;i<tips.length;i++){
        if(isColourTip(tips[i]) || normalizeInfoKey(tips[i].match)==='colour') return tips[i];
      }
    }
    if(type==='uv print'){
      for(i=0;i<tips.length;i++){
        if(tips[i].illustration==='uv' || normalizeInfoKey(tips[i].match)==='uv print') return tips[i];
      }
    }
    for(i=0;i<tips.length;i++){
      if(normalizeInfoKey(tips[i].match)===type) return tips[i];
    }
    return null;
  }
  function openInfo(key){
    // Re-load tips from JSON tag if CONFIG lost them (empty modal shell)
    if(!CFG.infoTips || !CFG.infoTips.length){
      CFG.infoTips = loadInfoTipsFromDom();
      if(window.DUPV2_CONFIG) window.DUPV2_CONFIG.infoTips = CFG.infoTips;
    }
    var tip=resolveInfoTip(key);
    if(tip && !tipHasBody(tip)){
      // Matched a stub — prefer a tip that actually has copy
      var richer=findInfoTipByType(normalizeInfoKey(key))||findInfoTipByType(normalizeInfoKey(tip.match));
      if(richer && tipHasBody(richer)) tip=richer;
    }
    // Never no-op on i-click: if tip blocks failed to match, still open modal with best available tip
    if(!tip || !tipHasBody(tip)){
      var tips=CFG.infoTips||[];
      var nk=normalizeInfoKey(key);
      if(nk) tip=findInfoTipByType(nk);
      if((!tip || !tipHasBody(tip)) && tips.length){
        tip=findInfoTipByType('colour')||findInfoTipByType('delivery')||findInfoTipByType('backboard')||tips[0];
      }
      if(!tip){
        tip={ match:key||'', title:key||'', kicker:'', okLabel:'', answer:'' };
      }
    }
    var titleEl=document.getElementById('isTitle');
    var bodyEl=document.getElementById('isBody');
    var modal=document.getElementById('infoModal');
    if(!titleEl||!bodyEl||!modal) return;
    titleEl.textContent=tip.title||tip.match||key||'';
    var kickerEl=document.getElementById('isKicker');
    // Never force English chrome over merchant copy
    if(kickerEl) kickerEl.textContent=tip.kicker||'';
    var okEl=document.getElementById('isOk');
    var okTxt=tip.okLabel||tip.okChoose||'';
    if(okEl){
      okEl.textContent=okTxt;
      okEl.style.display=okTxt ? '' : 'none';
    }
    try {
      bodyEl.innerHTML=buildInfoHtml(tip)||(tip.answer?'<p class="is-answer">'+tip.answer+'</p>':'');
    } catch (err) {
      bodyEl.innerHTML=tip.answer?'<p class="is-answer">'+tip.answer+'</p>':'';
    }
    // Colour modal always keeps a visible OK button (buildColourInfoHtml sets the label)
    if(okEl && (normalizeInfoKey(tip.match)==='colour' || isColourTip(tip))){
      if(!okEl.textContent || /\{color\}/i.test(okEl.textContent)){
        var selOk=document.getElementById('selColor');
        var curName=selOk&&selOk.selectedOptions[0] ? (selOk.selectedOptions[0].textContent||'') : '';
        var okTpl2=tip.okChoose||tip.okLabel||'';
        okEl.textContent = okTpl2 ? tpl(okTpl2, { color: curName, n: selOk ? selOk.options.length : 0 }) : (curName||'Got it');
        if(/\{color\}/i.test(okEl.textContent)) okEl.textContent = curName || 'Got it';
      }
      okEl.style.display='';
    }
    modal.classList.add('open');
    document.documentElement.classList.add('dupv2-info-open');
    // Prevent stuck horizontal scroll clipping colour grid / titles on mobile
    var sheet=modal.querySelector('.info-sheet');
    if(sheet) sheet.scrollLeft=0;
    bodyEl.scrollLeft=0;
    bodyEl.querySelectorAll('video[autoplay]').forEach(function(v){
      var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
    });
  }
  function closeInfo(){
    var bodyEl=document.getElementById('isBody');
    if(bodyEl) bodyEl.querySelectorAll('video').forEach(function(v){ try{v.pause();}catch(e){} });
    var modal=document.getElementById('infoModal');
    if(modal) modal.classList.remove('open');
    document.documentElement.classList.remove('dupv2-info-open');
  }
  function tipLabelFrom(el){
    if(!el) return '';
    if(el.dataset && el.dataset.title) return el.dataset.title;
    var tip=el.closest && el.closest('.oinfo');
    if(tip && tip.dataset.title) return tip.dataset.title;
    var row=el.closest && el.closest('.orow');
    if(row){
      var ol=row.querySelector('.ol');
      if(ol){
        var clone=ol.cloneNode(true);
        clone.querySelectorAll('.tip,.oinfo,.tip-pop').forEach(function(n){ n.remove(); });
        return clone.textContent.trim();
      }
    }
    return '';
  }
  // Always show i-icons; open modal via capture so tip handlers cannot block
  document.querySelectorAll('.oinfo, .dinfo').forEach(function(el){
    if (el && el.style) el.style.display = '';
  });
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest && e.target.closest('.optlist .oinfo .ibtn, .sz-cut .oinfo .ibtn, .dinfo, .oinfo .ibtn, .oinfo, .dinfo');
    if (!b) return;
    // Ignore tip-pop content clicks inside oinfo (hover text only)
    if (e.target.closest && e.target.closest('.tip-pop') && !e.target.closest('.ibtn')) return;
    if (!document.getElementById('infoModal')) return;
    e.preventDefault();
    e.stopPropagation();
    var key = tipLabelFrom(b) || (b.dataset && b.dataset.title) || '';
    if (b.classList.contains('dinfo') || (b.classList && b.classList.contains('dinfo'))) {
      key = key || CFG.tipMatchDelivery || 'delivery';
    }
    if (!key) {
      var oinfo = b.classList && b.classList.contains('oinfo') ? b : (b.closest && b.closest('.oinfo'));
      if (oinfo && oinfo.dataset.title) key = oinfo.dataset.title;
    }
    openInfo(key);
  }, true);
  ['isClose','isOk'].forEach(function(id){
    var el=document.getElementById(id);
    if(el) el.addEventListener('click', closeInfo);
  });
  var infoModal=document.getElementById('infoModal');
  if(infoModal) infoModal.addEventListener('click', function(e){ if(e.target===this) closeInfo(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeInfo(); });
  var isBody=document.getElementById('isBody');
  if(isBody){
    isBody.addEventListener('click', function(e){
      var pick=e.target.closest('[data-pick]');
      if(pick){
        var ps=document.getElementById('selColor');
        if(ps){
          ps.selectedIndex=+pick.dataset.pick;
          ps.dispatchEvent(new Event('change',{bubbles:true}));
        }
        openInfo(OPT_COLOR ? OPT_COLOR.name : (CFG.colourOptionName || 'Colour'));
        return;
      }
      var tile=e.target.closest('.is-color[data-video]');
      if(tile && !tile.querySelector('video')){
        tile.insertAdjacentHTML('afterbegin','<video src="'+tile.dataset.video+'" autoplay muted loop playsinline></video>');
        tile.classList.add('playing');
        return;
      }
      var sw=e.target.closest('.is-switch');
      if(sw){
        var s=document.getElementById('selColor');
        if(s && sw.dataset.color!=null){
          var idx=+sw.dataset.color;
          if(!isNaN(idx) && idx>=0 && idx<s.options.length){
            s.selectedIndex=idx;
            s.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
        openInfo(OPT_COLOR ? OPT_COLOR.name : 'Colour');
      }
    });
  }

  document.addEventListener('change', function(e){ if(e.target.closest('.optlist')){ updDeltas(); syncVals(); drawMini(); updStep(); } });
  (function(){ if(!('IntersectionObserver' in window)) return;
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target; if(e.isIntersecting){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else v.pause(); }); },{threshold:.3});
    document.querySelectorAll('.ugc video,.boxvid,.bx8 video').forEach(function(v){ io.observe(v); }); })();
  updDeltas(); syncVals(); drawMini(); updStep();
  var selColorBoot=document.getElementById('selColor');
  if(selColorBoot) selColorBoot.dispatchEvent(new Event('change',{bubbles:true}));

  // Hoogte van banner + header → CSS-variabele, zodat sticky foto en scroll-ankers eronder vallen
  (function(){
    var st=document.getElementById('topstack');
    var rootEl=document.querySelector('.dupv2') || document.documentElement;
    function upd(){
      var sh = st ? st.offsetHeight : 0;
      // Theme upgraded header + discount bar (same idea as custom_neon)
      if (!st) {
        var hdr = document.querySelector('.header.upgraded-header') || document.querySelector('header.site-header, .shopify-section-header');
        var banner = document.querySelector('.discount-top-bar-header');
        if (hdr) {
          var stack = hdr.closest('.shopify-section') || hdr.parentElement;
          if (stack && stack.getBoundingClientRect) sh = Math.round(stack.getBoundingClientRect().height) || hdr.offsetHeight || 0;
          else sh = hdr.offsetHeight || 0;
        }
        if (banner) {
          var cs = window.getComputedStyle(banner);
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && banner.offsetHeight > 0) {
            // included in section height usually; only add if not already inside measured stack
          }
        }
        if (!sh) sh = 106;
      }
      rootEl.style.setProperty('--stackh', sh+'px');
      document.documentElement.style.setProperty('--stackh', sh+'px');
      // Match neonsfeer-collectie-productpagina.html: square stage = media-col width
      var col=document.querySelector('.dupv2 .media-col'), stage=document.querySelector('.dupv2 .stage');
      if(col && stage && window.innerWidth>1000){
        var rest=col.offsetHeight-stage.offsetHeight;
        var max=window.innerHeight-sh-16-rest-16;
        var natural=col.offsetWidth;
        var target=Math.round(Math.min(natural, Math.max(260, max)));
        rootEl.style.setProperty('--stageh', target+'px');
        document.documentElement.style.setProperty('--stageh', target+'px');
      } else {
        rootEl.style.removeProperty('--stageh');
        document.documentElement.style.removeProperty('--stageh');
      }
    }
    upd(); window.addEventListener('resize', upd); window.addEventListener('load', upd);
    try{ if(window.ResizeObserver){ new ResizeObserver(upd).observe(document.querySelector('.dupv2 .buy-col')||rootEl); } }catch(e){}
  })();

  // Delivery ETA — same logic/format as custom_neon (calendar days → "11–15 November")
  (function(){
    var el=document.getElementById('eta'); if(!el) return;
    var months={
      default:['January','February','March','April','May','June','July','August','September','October','November','December'],
      fr:['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'],
      es:['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
      de:['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
      nl:['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'],
      it:['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'],
      sv:['januari','februari','mars','april','maj','juni','juli','augusti','september','oktober','november','december']
    };
    var lang=(document.documentElement.lang||'default').toLowerCase().split('-')[0];
    var M=months[lang]||months.default;
    var d=syncDeliveryDays();
    function future(n){ var dt=new Date(); dt.setDate(dt.getDate()+n); return {day:dt.getDate(), monthIndex:dt.getMonth()}; }
    var a=future(d.min), b=(d.max!==d.min)?future(d.max):null;
    var text;
    if(b && a.monthIndex===b.monthIndex) text=a.day+'\u2013'+b.day+' '+M[a.monthIndex];
    else if(b) text=a.day+' '+M[a.monthIndex]+' \u2013 '+b.day+' '+M[b.monthIndex];
    else text=a.day+' '+M[a.monthIndex];
    el.textContent=text;
    document.querySelectorAll('.dlv-days').forEach(function(e){
      e.textContent=d.min===d.max ? String(d.min) : (d.min+' to '+d.max);
    });
  })();

  // Kortingscode kopiëren
  (function(){
    var c=document.getElementById('copyCode'); if(!c) return;
    c.addEventListener('click', function(){
      var txt=c.textContent;
      try{ navigator.clipboard.writeText('BACK2WORK'); }catch(e){}
      c.textContent='Copied ✓'; setTimeout(function(){ c.textContent=txt; },1500);
    });
  })();

  // Sticky onderbalk pas tonen zodra de hoofdknop "Bestel nu" boven uit beeld is gescrold
  (function(){
    var bar=document.querySelector('.sticky-bar'), main=document.getElementById('atcMain');
    if(!bar||!main) return;
    function check(){
      var r=main.getBoundingClientRect();
      bar.classList.toggle('show', r.bottom < 0);
    }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(){ check(); },{threshold:0}).observe(main);
    }
    window.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check);
    check();
  })();


  // Desktop: rows that swipe on mobile get arrows (reviews) and mouse drag (reviews, colour thumbnails, customer videos)
  (function(){
    function wireRail(r){
      if(!r || r.dataset.railBound) return;
      r.dataset.railBound = '1';
      var id = r.id;
      var btns = id ? document.querySelectorAll('[data-dupv2-rail-btn="'+id+'"], [data-rail="'+id+'"]') : [];
      function step(){ var c=r.firstElementChild; return c ? c.offsetWidth+14 : 300; }
      function upd(){
        if(!btns.length) return;
        if(btns[0]) btns[0].disabled = r.scrollLeft<=2;
        if(btns[1]) btns[1].disabled = r.scrollLeft+r.clientWidth>=r.scrollWidth-2;
      }
      btns.forEach(function(btn){ btn.addEventListener('click', function(){ r.scrollBy({left:+btn.dataset.d*step()*2, behavior:'smooth'}); }); });
      r.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd); upd();
    }
    document.querySelectorAll('[data-dupv2-rail], #rv9Rail, #pr9Rail').forEach(wireRail);

    function dragScroll(el){
      if(!el || el.dataset.dragBound) return; el.dataset.dragBound='1'; el.classList.add('drag-scroll');
      var down=false, moved=false, x0=0, s0=0;
      el.addEventListener('mousedown', function(e){ if(e.button!==0) return; down=true; moved=false; x0=e.pageX; s0=el.scrollLeft; });
      window.addEventListener('mousemove', function(e){ if(!down) return; var dx=e.pageX-x0; if(Math.abs(dx)>5){ moved=true; el.classList.add('dragging'); } if(moved){ el.scrollLeft=s0-dx; e.preventDefault(); } });
      window.addEventListener('mouseup', function(){ if(!down) return; down=false; setTimeout(function(){ el.classList.remove('dragging'); },0); });
      el.addEventListener('click', function(e){ if(moved){ e.stopPropagation(); e.preventDefault(); moved=false; } }, true);
    }
    document.querySelectorAll('[data-dupv2-rail], #rv9Rail, #pr9Rail, .dupv2 .thumbs, .dupv2 .ugc').forEach(dragScroll);
  })();


  // Your neon, explained: tabs switch text/media; Why EcoLED image follows selected colour/variant
  (function(){
    document.querySelectorAll('[data-yx-tabs]').forEach(function(tabs){
      if(tabs.dataset.yxBound) return;
      tabs.dataset.yxBound = '1';
      var root = tabs.closest('.yx') || tabs.closest('.dupv2') || document;
      var mediaRoot = root.querySelector('[data-yx-media]') || root.querySelector('.yx-media');
      var media = mediaRoot ? [].slice.call(mediaRoot.children) : [];
      var panes = root.querySelectorAll('[data-yx-pane], .yx-pane');
      var vid = root.querySelector('[data-yx-vid]') || root.querySelector('video');
      tabs.addEventListener('click', function(e){
        var b=e.target.closest('button'); if(!b) return; var t=+b.dataset.t;
        [].forEach.call(tabs.children, function(x,i){ x.classList.toggle('on', i===t); x.setAttribute('aria-selected', i===t); });
        [].forEach.call(panes, function(p,i){ p.classList.toggle('on', i===t); });
        media.forEach(function(m,i){ m.classList.toggle('on', i===t); });
        if(vid){
          if(media[t]===vid){ var p=vid.play(); if(p&&p.catch) p.catch(function(){}); }
          else vid.pause();
        }
        // Refresh variant photo when opening Why EcoLED / Specs
        if (t === 1 || t === 2) { try { syncYxProdImages(); } catch (e2) {} }
      });
      if(vid && 'IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting && vid.classList.contains('on')){ var p=vid.play(); if(p&&p.catch) p.catch(function(){}); } else vid.pause(); }); },{threshold:.3}).observe(vid);
      }
    });
    var sel=document.getElementById('selColor');
    if(sel){
      sel.addEventListener('change', function(){ try { syncYxProdImages(); } catch (e) {} });
    }
    try { syncYxProdImages(); } catch (e0) {}
  })();

})();
